import type { PromptTemplateSummary } from '../types';

export const AR_SKILL_COPY: Record<string, { description?: string; examplePrompt?: string }> = {
  '8-bit-orbit-video-template': {
    description:
      'قالب فيديو قائم على Hyperframes لتصميم حركة عروض البكسل الكلاسيكية (retro pixel deck).\nاستخدمه عندما يريد المستخدمون تكوين فيديو متعدد المشاهد عالي الدقة من HTML-to-video\nمع انتقالات متقدمة، وعناصر تحكم تفاعلية للمعاينة، ونمط افتراضي جاهز\nللتصيير (render).',
    examplePrompt:
      'أنشئ عرض فيديو من 3 صفحات باستخدام Hyperframes بأسلوب 8-bit الكلاسيكي مع انتقالات متقدمة وحركة غنية، بحيث تكون كل صفحة أقل من 3 ثوانٍ.',
  },
  'ad-creative': {
    description:
      'أنشئ وكرِّر محتوى إعلانيًا إبداعيًا يشمل العناوين والأوصاف والنص الأساسي. مفيد لتكرار إعلانات وسائل التواصل المدفوعة وإعلانات البحث.',
    examplePrompt:
      'أنشئ وكرِّر محتوى إعلانيًا إبداعيًا يشمل العناوين والأوصاف والنص الأساسي.',
  },
  'after-hours-editorial-template': {
    description:
      'قالب HyperFrames فاخر بأسلوب تحريري داكن للوحات قصصية سينمائية من ثلاث صفحات،\nمستوحى من بطاقات عناوين الأزياء الراقية (haute couture) وصفحات فصول المجلات. استخدمه عندما\nيطلب المستخدم صفحات حركة بطابع الموضة الفاخرة، أو سردًا قصصيًا أنيقًا يعتمد على خطوط serif ذات أجواء مؤثرة،\nأو جمالية عرض داكنة راقية مع انتقالات غنية.',
    examplePrompt:
      'أنشئ تسلسلًا تحريريًا من ثلاث صفحات باستخدام HyperFrames بأسلوب haute couture داكن: طباعة serif فاخرة، ولمسة لون أرجواني (magenta)، وانتقالات أنيقة بين الفصول، وحُبيبات سينمائية. اجعل كل صفحة أقل من 3 ثوانٍ.',
  },
  'agent-browser': {
    description:
      'أداة CLI لأتمتة المتصفح لوكلاء الذكاء الاصطناعي. استخدمها عندما يحتاج المستخدم إلى فحص\nسلوك المتصفح أو اختباره أو أتمتته: التنقل بين الصفحات، وملء النماذج،\nوالنقر على الأزرار، والتقاط لقطات الشاشة، واستخراج بيانات الصفحة، وقراءة سياق علامة تبويب\nمتصفح Open Design المحدد، واختبار تطبيقات الويب، وتجربة معاينات Open Design داخليًا (dogfooding)،\nوضمان الجودة (QA)، واصطياد الأخطاء، أو مراجعة جودة التطبيق. فضّل عناوين URL لمعاينة Open Design\nالمحلية ما لم يطلب المستخدم صراحةً التصفح الخارجي.',
    examplePrompt:
      'أداة CLI لأتمتة المتصفح لوكلاء الذكاء الاصطناعي.',
  },
  'ai-music-album': {
    description:
      'إنتاج ألبوم موسيقي بالذكاء الاصطناعي بدورة حياة كاملة — المفهوم، وصياغة الكلمات، وترتيب المقطوعات، والتصدير. مفيد لتجارب الألبومات المستقلة والمقطوعات الصوتية للعلامات التجارية.',
    examplePrompt:
      'إنتاج ألبوم موسيقي بالذكاء الاصطناعي بدورة حياة كاملة — المفهوم، وصياغة الكلمات، وترتيب المقطوعات، والتصدير.',
  },
  'algorithmic-art': {
    description:
      'أنشئ فنًا توليديًا باستخدام p5.js مع عشوائية مُبذَّرة (seeded) بحيث يكون كل تصيير قابلاً لإعادة الإنتاج. مفيد للملصقات الإجرائية، والصور الثابتة ذات الطابع الحركي، ودراسات الإطارات الفنية.',
    examplePrompt:
      'أنشئ فنًا توليديًا باستخدام p5.js مع عشوائية مُبذَّرة (seeded) بحيث يكون كل تصيير قابلاً لإعادة الإنتاج.',
  },
  'apple-hig': {
    description:
      'إرشادات واجهة Apple البشرية (Human Interface Guidelines) في صورة 14 مهارة للوكيل تغطي المنصات، والأسس، والمكونات، والأنماط، والمدخلات، والتقنيات لأنظمة iOS وmacOS وvisionOS وwatchOS وtvOS.',
    examplePrompt:
      'إرشادات واجهة Apple البشرية (Human Interface Guidelines) في صورة 14 مهارة للوكيل تغطي المنصات، والأسس، والمكونات، والأنماط، والمدخلات، والتقنيات لأنظمة iOS وmacOS وvisionOS وwatchOS وtvOS.',
  },
  'article-magazine': {
    description:
      'تخطيط مقال مجلة مستوحى من Huashu / huashu-md-html لتحويل Markdown أو الملاحظات إلى مقال HTML مطوّل ومصقول.',
    examplePrompt:
      'استخدم قالب Magazine Article لتحويل محتواي إلى مقال HTML مطوّل مستوحى من Huashu / huashu-md-html. حافظ على البصمة البصرية للقالب، واستخدم محتوى وبيانات حقيقية، وتجنّب نص lorem ipsum أو الصور النائبة.',
  },
  'artifacts-builder': {
    description:
      'مجموعة أدوات لإنشاء أعمال HTML تفصيلية متعددة المكونات على claude.ai باستخدام تقنيات الويب الأمامية الحديثة (React وTailwind CSS وshadcn/ui).',
    examplePrompt:
      'مجموعة أدوات لإنشاء أعمال HTML تفصيلية متعددة المكونات على claude.ai باستخدام تقنيات الويب الأمامية الحديثة (React وTailwind CSS وshadcn/ui).',
  },
  'brainstorming': {
    description:
      'حوّل الأفكار الأولية إلى تصاميم مكتملة من خلال طرح أسئلة منظمة واستكشاف بدائل. مفيد في المراحل المبكرة من العمل على المفهوم.',
    examplePrompt:
      'حوّل الأفكار الأولية إلى تصاميم مكتملة من خلال طرح أسئلة منظمة واستكشاف بدائل.',
  },
  'brand-guidelines': {
    description:
      'طبّق ألوان وخطوط علامة Anthropic الرسمية على الأعمال لتحقيق هوية بصرية متسقة ومعايير تصميم احترافية. مرجع لتشكيل هويتك الخاصة.',
    examplePrompt:
      'طبّق ألوان وخطوط علامة Anthropic الرسمية على الأعمال لتحقيق هوية بصرية متسقة ومعايير تصميم احترافية.',
  },
  'brandkit': {
    description:
      'مهارة فاخرة لتوليد صور حقائب العلامة التجارية (brand-kit) لإنشاء لوحات إرشادات العلامة الراقية، وأنظمة الشعارات، وعروض الهوية، وعروض العوالم البصرية. مُدرَّبة على أنظمة علامات تجارية بأساليب البساطة (minimalist) والسينمائية والتحريرية والتقنية الداكنة (dark-tech) والفاخرة والثقافية والأمنية والألعاب وأدوات المطورين وتطبيقات المستهلكين. مُحسّنة لابتكار مفاهيم الشعارات المقصودة، والتكوين المصقول، والطباعة المتقشفة، والمعنى الرمزي القوي، والنماذج الفاخرة (mockups)، والصور الموجَّهة فنيًا، وتخطيطات الشبكات المرنة.',
    examplePrompt:
      'أنشئ صورة نظرة عامة فاخرة لحقيبة العلامة التجارية (brand-kit) لهذا المنتج: توجّه الشعار، ولوحة الألوان، والطباعة، والتطبيقات، وعالم بصري متماسك.',
  },
  'industrial-brutalist-ui': {
    description:
      'واجهات ميكانيكية خام تمزج الطباعة السويسرية المطبوعة بجماليات الطرفيات العسكرية. شبكات صارمة، وتباين شديد في مقياس الخطوط، وألوان نفعية، وتأثيرات تدهور تناظرية (analog). مناسبة للوحات المعلومات كثيفة البيانات، أو محافظ الأعمال، أو المواقع التحريرية التي تحتاج أن تبدو كمخططات مرفوعة السرية.',
    examplePrompt:
      'أنشئ واجهة صناعية بروتالية (industrial-brutalist) بشبكات صارمة، وعناصر قياس عن بُعد (telemetry) تكتيكية، وطباعة قوية، ودقة ميكانيكية.',
  },
  'canvas-design': {
    description:
      'أنشئ فنًا بصريًا جميلًا في مستندات PNG وPDF باستخدام فلسفة التصميم والمبادئ الجمالية للملصقات والرسوم التوضيحية والقطع الثابتة.',
    examplePrompt:
      'أنشئ فنًا بصريًا جميلًا في مستندات PNG وPDF باستخدام فلسفة التصميم والمبادئ الجمالية للملصقات والرسوم التوضيحية والقطع الثابتة.',
  },
  'card-twitter': {
    description:
      'بطاقة اقتباس أو بيانات على Twitter مصممة لتُرفق مع منشور.',
    examplePrompt:
      'استخدم قالب Twitter Share Card لتحويل محتواي إلى بطاقة اقتباس أو بيانات على Twitter مصممة لتُرفق مع منشور. حافظ على البصمة البصرية للقالب، واستخدم محتوى وبيانات حقيقية، وتجنّب نص lorem ipsum أو الصور النائبة.',
  },
  'card-xiaohongshu': {
    description:
      'بطاقات معرفية بأسلوب Xiaohongshu، مرتبة كدوّار (carousel) متعدد البطاقات قابل للتمرير.',
    examplePrompt:
      'استخدم قالب Xiaohongshu Card لتحويل محتواي إلى دوّار بطاقات معرفية قابل للتمرير بأسلوب Xiaohongshu. حافظ على البصمة البصرية للقالب، واستخدم محتوى وبيانات حقيقية، وتجنّب نص lorem ipsum أو الصور النائبة.',
  },
  'color-expert': {
    description:
      'مهارة خبير في علم الألوان مع مادة مرجعية من 286 ألف كلمة تغطي OKLCH/OKLAB، وتوليد لوحات الألوان، وإمكانية الوصول/التباين، وتسمية الألوان، ومزج الأصباغ، ونظرية الألوان التاريخية.',
    examplePrompt:
      'مهارة خبير في علم الألوان مع مادة مرجعية من 286 ألف كلمة تغطي OKLCH/OKLAB، وتوليد لوحات الألوان، وإمكانية الوصول/التباين، وتسمية الألوان، ومزج الأصباغ، ونظرية الألوان التاريخية.',
  },
  'competitive-ads-extractor': {
    description:
      'استخرج وحلّل إعلانات المنافسين من مكتبات الإعلانات لفهم الرسائل والأساليب الإبداعية التي تلقى صدى.',
    examplePrompt:
      'استخرج وحلّل إعلانات المنافسين من مكتبات الإعلانات لفهم الرسائل والأساليب الإبداعية التي تلقى صدى.',
  },
  'copywriting': {
    description:
      'اكتب وأعد كتابة النصوص التسويقية لصفحات الهبوط والصفحات الرئيسية والإعلانات. مفيد كشريك رئيس تحرير للنصوص أثناء الإطلاقات.',
    examplePrompt:
      'اكتب وأعد كتابة النصوص التسويقية لصفحات الهبوط والصفحات الرئيسية والإعلانات.',
  },
  'creative-director': {
    description:
      'مدير إبداعي بالذكاء الاصطناعي مع تقييم ذاتي تكراري: أكثر من 20 منهجية (SIT وTRIZ وBisociation وSCAMPER وSynectics)، وتقييم ثلاثي المحاور معاير وفق Cannes/D&AD/HumanKind، وعملية من 5 مراحل من الموجز إلى العرض التقديمي.',
    examplePrompt:
      'مدير إبداعي بالذكاء الاصطناعي مع تقييم ذاتي تكراري: أكثر من 20 منهجية (SIT وTRIZ وBisociation وSCAMPER وSynectics)، وتقييم ثلاثي المحاور معاير وفق Cannes/D&AD/HumanKind، وعملية من 5 مراحل من الموجز إلى العرض التقديمي.',
  },
  'd3-visualization': {
    description:
      'يُعلّم الوكيل إنتاج مخططات D3 وتصورات بيانات تفاعلية. مهارة شاملة في D3.js مع أمثلة تغطي أنواع المخططات والتقنيات، تمنح الوكيل معرفة بمستوى الخبراء لإنشاء تصورات معقدة وتفاعلية. مفيدة للوحات المعلومات التحريرية، والتقارير، والنماذج الأولية الغنية بالبيانات، والرسومات التوضيحية.',
    examplePrompt:
      'يُعلّم الوكيل إنتاج مخططات D3 وتصورات بيانات تفاعلية.',
  },
  'data-report': {
    description:
      'يحوّل بيانات CSV أو Excel أو JSON إلى صفحة تقرير مرئي متقن.',
    examplePrompt:
      'استخدم قالب Data Visualization Report لتحويل بيانات CSV أو Excel أو JSON الخاصة بي إلى صفحة تقرير مرئي متقن. حافظ على البصمة البصرية للقالب، واستخدم محتوى وبيانات حقيقية، وتجنّب نص lorem ipsum أو الصور النائبة.',
  },
  'deck-guizang-editorial': {
    description:
      'مجلة تحريرية تلتقي بالحبر الإلكتروني: 10 تخطيطات و5 لوحات ألوان (Ink، Indigo Porcelain، Forest Ink، Kraft Paper، Dune).',
    examplePrompt:
      'استخدم قالب Guizang Editorial E-Ink Deck لتحويل محتواي إلى عرض أفقي بنمط المجلة التحريرية × الحبر الإلكتروني مع 10 تخطيطات و5 لوحات ألوان. حافظ على البصمة البصرية للقالب، واستخدم محتوى وبيانات حقيقية، وتجنّب نص lorem ipsum أو الصور النائبة.',
  },
  'deck-open-slide-canvas': {
    description:
      'عرض بلوحة رسم مثبّتة بدقة 1920x1080 مع تأليف حر على مستوى مكوّنات React، غير مقيّد بقالب ثابت.',
    examplePrompt:
      'استخدم قالب Open-Slide 1920 Canvas Deck لتحويل محتواي إلى عرض بتأليف حر مثبّت بدقة 1920x1080 مع تخطيط على مستوى مكوّنات React. حافظ على البصمة البصرية للقالب، واستخدم محتوى وبيانات حقيقية، وتجنّب نص lorem ipsum أو الصور النائبة.',
  },
  'deck-swiss-international': {
    description:
      'شبكة من 16 عمودًا، ولون تمييز مُشبَع واحد، و22 تخطيطًا مثبّتًا (Klein Blue، Lemon، Mint، Safety Orange).',
    examplePrompt:
      'استخدم قالب Swiss International Deck لتحويل محتواي إلى عرض بشبكة من 16 عمودًا مع لون تمييز مُشبَع واحد و22 تخطيطًا مثبّتًا. حافظ على البصمة البصرية للقالب، واستخدم محتوى وبيانات حقيقية، وتجنّب نص lorem ipsum أو الصور النائبة.',
  },
  'design-brief': {
    description:
      'حلّل موجزًا تصميميًا منظّمًا مكتوبًا بصيغة بروتوكول I-Lang إلى\nمواصفات تصميم ملموسة. يزيل الغموض من الطلبات المبهمة مثل\n"اجعله احترافيًا" عبر اشتراط أبعاد صريحة: لوحة الألوان، والطباعة،\nوالتخطيط، والمزاج، والكثافة، والقيود.\nالكلمات المفتاحية المُطلِقة: "design brief"، "create a design brief"، "ilang brief"، "structured brief".',
    examplePrompt:
      'حلّل موجزًا تصميميًا منظّمًا مكتوبًا بصيغة بروتوكول I-Lang إلى مواصفات تصميم ملموسة.',
  },
  'design-consultation': {
    description:
      'ابنِ نظام تصميم كاملًا من الصفر مع مخاطر إبداعية ونماذج منتجات واقعية. مفيد لورش العمل الافتتاحية وأعمال بناء العلامة التجارية من الصفر.',
    examplePrompt:
      'ابنِ نظام تصميم كاملًا من الصفر مع مخاطر إبداعية ونماذج منتجات واقعية.',
  },
  'design-md': {
    description:
      'أنشئ وأدِر ملفات DESIGN.md. مفيد لالتقاط التوجّه التصميمي والرموز والقواعد البصرية في مصدر واحد موثوق.',
    examplePrompt:
      'أنشئ وأدِر ملفات DESIGN.md.',
  },
  'design-review': {
    description:
      'مصمّم يبرمج: تدقيق بصري ثم إصلاحات مع تثبيتات ذرّية ولقطات شاشة قبل/بعد. مفيد لإحكام واجهة المستخدم المُطلَقة قبل الإطلاق.',
    examplePrompt:
      'مصمّم يبرمج: تدقيق بصري ثم إصلاحات مع تثبيتات ذرّية ولقطات شاشة قبل/بعد.',
  },
  'digits-fintech-swiss-template': {
    description:
      'قالب عرض للتكنولوجيا المالية بشبكة سويسرية بتباين الأسود / الورق الدافئ / الليموني النيون.\nاستخدمه عندما يطلب المستخدمون شرائح قصص بيانات فاخرة بتخطيط نمطي صارم،\nوبطاقات رقمية جريئة، وحركة متحفّظة، وتنقّل بلوحة المفاتيح/النقر في ملف HTML واحد.',
    examplePrompt:
      'أنشئ عرض استراتيجية للتكنولوجيا المالية بشبكة سويسرية مع بطاقات بيانات نمطية، ولمسات ليمونية، وتنقّل نظيف بلوحة المفاتيح.',
  },
  'doc': {
    description:
      'اقرأ وأنشئ وحرّر مستندات .docx مع الحفاظ على دقة التنسيق والتخطيط عبر مهارة المستندات من OpenAI.',
    examplePrompt:
      'اقرأ وأنشئ وحرّر مستندات .docx مع الحفاظ على دقة التنسيق والتخطيط عبر مهارة المستندات من OpenAI.',
  },
  'doc-kami-parchment': {
    description:
      'لوحة رسم بلون الرَّق الدافئ (#f5f4ed)، ولمسة أحادية اللون بالأزرق الحبري (#1B365D)، وعائلة خطوط مذيّلة واحدة، وطباعة بمستوى تحريري.',
    examplePrompt:
      'استخدم قالب Kami Parchment Document لتحويل محتواي إلى مستند بلون الرَّق الدافئ مع لمسات أحادية اللون بالأزرق الحبري، وعائلة خطوط مذيّلة واحدة، وطباعة بمستوى تحريري. حافظ على البصمة البصرية للقالب، واستخدم محتوى وبيانات حقيقية، وتجنّب نص lorem ipsum أو الصور النائبة.',
  },
  'docx': {
    description:
      'أنشئ وحرّر وحلّل مستندات Word مع تتبّع التغييرات والتعليقات والتنسيق. مفيد للموجزات التصميمية، ومستندات النصوص، والمخرجات الجاهزة للمراجعة.',
    examplePrompt:
      'أنشئ وحرّر وحلّل مستندات Word مع تتبّع التغييرات والتعليقات والتنسيق.',
  },
  'domain-name-brainstormer': {
    description:
      'ولّد أفكارًا إبداعية لأسماء النطاقات وتحقّق من توفّرها عبر امتدادات نطاقات عُليا متعددة بما فيها .com و.io و.dev و.ai.',
    examplePrompt:
      'ولّد أفكارًا إبداعية لأسماء النطاقات وتحقّق من توفّرها عبر امتدادات نطاقات عُليا متعددة بما فيها .com و.io و.dev و.ai.',
  },
  'ecommerce-image-workflow': {
    description:
      'سير عمل صور التجارة الإلكترونية القائم على المنتج المرجعي لإنشاء مجموعة مُحكمة\nمن الصور الرئيسية وصور الميزات وصور أسلوب الحياة المطابقة للمنتج انطلاقًا من\nصور مرجعية حقيقية للمنتج. يتطلّب الإصدار V1 رفع صور المنتج ويؤجّل عمدًا\nتوليد المفاهيم القائم على الموجز فقط وعمليات التصدير الدفعية الخاصة بكل منصة.',
    examplePrompt:
      'استخدم Ecommerce Image Workflow لتحويل صورة المنتج المرجعية التي رفعتُها\nإلى مجموعة مُحكمة من صور التجارة الإلكترونية: صورة عبوة رئيسية واحدة، وصورة\nإبراز ميزة واحدة، ومشهد أسلوب حياة واحد. حافظ على الهوية الدقيقة للمنتج،\nواللون، والخامة، وموضع الشعار، والبنية، والنِّسَب.',
  },
  'editorial-burgundy-principles-template': {
    description:
      'قالب عرض استوديو تحريري بلوحة ألوان من العنابي / الوردي الفاتح / الذهبي الباهت.\nاستخدمه عندما يطلب المستخدمون شرائح بيان أو ثقافة فاخرة مع وسوم بشكل أقراص،\nوعبارات طباعية كبيرة، وبطاقات مبادئ، وتنقّل موجَّه بلوحة المفاتيح/النقر.',
    examplePrompt:
      'أنشئ عرضًا تحريريًا فاخرًا بالعنابي والوردي الفاتح مع شريحة سحابة وسوم وشبكة بطاقات لثمانية مبادئ.',
  },
  'emilkowalski-motion': {
    description:
      'مهارة متابعة لتصميم الحركة مستوحاة من إرشادات الرسوم المتحركة لـ Emil Kowalski. استخدمها بعد وجود واجهة لإضافة تفاعلات دقيقة أنيقة، وانتقالات حالة، وحركة الصفحة بتحفّظ على مستوى المنتج.',
    examplePrompt:
      'استخدم emilkowalski-motion على عنصر HTML الحالي: أضِف تفاعلات دقيقة متحفّظة، وانتقالات حالة، وبدائل للحركة المخفّضة دون تغيير التخطيط الأساسي.',
  },
  'enhance-prompt': {
    description:
      'حسّن المطالبات بمواصفات تصميم ومفردات UI/UX. مفيد لسير عمل التحويل من التصميم إلى الكود وتوضيح طلبات المخرجات البصرية.',
    examplePrompt:
      'حسّن المطالبات بمواصفات تصميم ومفردات UI/UX.',
  },
  'export-download-debugging': {
    description:
      'شخّص وأصلح أعطال التصدير/التنزيل في المتصفح أو المعاينة أو Electron، لا سيما مشكلات تصدير الصور المتعلقة بـ Save As، وعناوين Blob/Data URLs، وواجهة File System Access API، وأعطال createWritable، وملفات 0 KB.',
    examplePrompt:
      'شخّص وأصلح أعطال التصدير/التنزيل في المتصفح أو المعاينة أو Electron، لا سيما مشكلات تصدير الصور المتعلقة بـ Save As، وعناوين Blob/Data URLs، وواجهة File System Access API، وأعطال createWritable، وملفات 0 KB.',
  },
  'fal-3d': {
    description:
      'ولّد نماذج ثلاثية الأبعاد من النص أو الصور عبر fal.ai. مفيد لأصول الألعاب، ومعاينات الواقع المعزز، ونماذج المنتجات، والنحت المفاهيمي.',
    examplePrompt:
      'ولّد نماذج ثلاثية الأبعاد من النص أو الصور عبر fal.ai.',
  },
  'fal-generate': {
    description:
      'توليد الصور ومقاطع الفيديو باستخدام نماذج الذكاء الاصطناعي من fal.ai. كتالوج بمستوى الإنتاج يغطي Flux وSDXL وideogram ونقاط نهاية أخرى مستضافة من المجتمع.',
    examplePrompt:
      'توليد الصور ومقاطع الفيديو باستخدام نماذج الذكاء الاصطناعي من fal.ai.',
  },
  'fal-image-edit': {
    description:
      'تحرير الصور المدعوم بالذكاء الاصطناعي مع نقل النمط وإزالة الخلفية وإزالة الكائنات والتعبئة الداخلية عبر النماذج المستضافة على fal.ai.',
    examplePrompt:
      'تحرير الصور المدعوم بالذكاء الاصطناعي مع نقل النمط وإزالة الخلفية وإزالة الكائنات والتعبئة الداخلية عبر النماذج المستضافة على fal.ai.',
  },
  'fal-kling-o3': {
    description:
      'توليد الصور ومقاطع الفيديو باستخدام Kling O3 — عائلة النماذج الأقوى من Kling — عبر fal.ai.',
    examplePrompt:
      'توليد الصور ومقاطع الفيديو باستخدام Kling O3 — عائلة النماذج الأقوى من Kling — عبر fal.ai.',
  },
  'fal-lip-sync': {
    description:
      'إنشاء مقاطع فيديو ناطقة ومزامنة الصوت مع حركة الشفاه في الفيديو عبر fal.ai. مفيد للأفاتارات التوضيحية ومعاينات الدبلجة متعددة اللغات والمقاطع الاجتماعية.',
    examplePrompt:
      'إنشاء مقاطع فيديو ناطقة ومزامنة الصوت مع حركة الشفاه في الفيديو عبر fal.ai.',
  },
  'fal-realtime': {
    description:
      'توليد الصور بالذكاء الاصطناعي في الوقت الفعلي وبالبث المباشر عبر fal.ai. مناسب لاستكشاف لوحات الإلهام وتنويعات المسودات والتكرار الإبداعي السريع.',
    examplePrompt:
      'توليد الصور بالذكاء الاصطناعي في الوقت الفعلي وبالبث المباشر عبر fal.ai.',
  },
  'fal-restore': {
    description:
      'استعادة جودة الصور وإصلاحها — إزالة التشويش والضبابية وإصلاح الوجوه واستعادة المستندات القديمة باستخدام نماذج الاستعادة المستضافة على fal.ai.',
    examplePrompt:
      'استعادة جودة الصور وإصلاحها — إزالة التشويش والضبابية وإصلاح الوجوه واستعادة المستندات القديمة باستخدام نماذج الاستعادة المستضافة على fal.ai.',
  },
  'fal-train': {
    description:
      'تدريب نماذج ذكاء اصطناعي مخصصة (LoRA) على fal.ai لتوليد صور مخصصة مصممة لعلامة تجارية أو شخصية أو نمط معين.',
    examplePrompt:
      'تدريب نماذج ذكاء اصطناعي مخصصة (LoRA) على fal.ai لتوليد صور مخصصة مصممة لعلامة تجارية أو شخصية أو نمط معين.',
  },
  'fal-tryon': {
    description:
      'التجربة الافتراضية — شاهد كيف تبدو الملابس على شخص ما عبر نماذج التجربة المستضافة على fal.ai. مفيد للتجارة الإلكترونية وكتالوجات الأزياء وتجارب التنسيق.',
    examplePrompt:
      'التجربة الافتراضية — شاهد كيف تبدو الملابس على شخص ما عبر نماذج التجربة المستضافة على fal.ai.',
  },
  'fal-upscale': {
    description:
      'رفع دقة الصور ومقاطع الفيديو وتحسينها باستخدام نماذج الدقة الفائقة بالذكاء الاصطناعي المستضافة على fal.ai.',
    examplePrompt:
      'رفع دقة الصور ومقاطع الفيديو وتحسينها باستخدام نماذج الدقة الفائقة بالذكاء الاصطناعي المستضافة على fal.ai.',
  },
  'fal-video-edit': {
    description:
      'تحرير مقاطع الفيديو الموجودة باستخدام الذكاء الاصطناعي — إعادة مزج النمط ورفع الدقة وإزالة الخلفية وإضافة الصوت عبر نماذج الفيديو المستضافة على fal.ai.',
    examplePrompt:
      'تحرير مقاطع الفيديو الموجودة باستخدام الذكاء الاصطناعي — إعادة مزج النمط ورفع الدقة وإزالة الخلفية وإضافة الصوت عبر نماذج الفيديو المستضافة على fal.ai.',
  },
  'fal-vision': {
    description:
      'تحليل الصور — تقسيم الكائنات واكتشافها وتشغيل التعرف الضوئي على الحروف والوصف والإجابة عن الأسئلة المرئية عبر نماذج الرؤية من fal.ai.',
    examplePrompt:
      'تحليل الصور — تقسيم الكائنات واكتشافها وتشغيل التعرف الضوئي على الحروف والوصف والإجابة عن الأسئلة المرئية عبر نماذج الرؤية من fal.ai.',
  },
  'faq-page': {
    description:
      'صفحة الأسئلة الشائعة (FAQ) مع أقسام أكورديون قابلة للطي،\nووظيفة بحث، وتصفية حسب الفئة. استخدمها عندما يطلب الموجز\n"الأسئلة الشائعة" أو "مركز المساعدة" أو "الأسئلة" أو "صفحة الدعم".',
    examplePrompt:
      'صفحة الأسئلة الشائعة (FAQ) مع أقسام أكورديون قابلة للطي، ووظيفة بحث، وتصفية حسب الفئة.',
  },
  'field-notes-editorial-template': {
    description:
      'قالب تقرير تحريري بنمط "Field Notes" مع خلفية ورقية ناعمة،\nوطباعة افتتاحية بخط مذيّل، وبطاقات رؤى باستيلية بحواف مستديرة، ولوحة مخطط الاحتفاظ.\nاستخدمه عندما يطلب المستخدمون تقرير أعمال فاخراً بنمط المجلات، أو مذكرة مجلس إدارة\nمن صفحة واحدة، أو تخطيطاً أنيقاً لسرد البيانات.',
    examplePrompt:
      'أنشئ تقريراً تحريرياً بنمط Field Notes مع ثلاث بطاقات رؤى، وكتل مقاييس رئيسية، ومخطط خطي للاحتفاظ في صفحة HTML أنيقة بملف واحد.',
  },
  'figma-code-connect-components': {
    description:
      'اربط مكونات تصميم Figma بمكونات الكود باستخدام Code Connect بحيث تتدفق تحديثات نظام التصميم إلى قاعدة الكود تلقائياً.',
    examplePrompt:
      'اربط مكونات تصميم Figma بمكونات الكود باستخدام Code Connect بحيث تتدفق تحديثات نظام التصميم إلى قاعدة الكود تلقائياً.',
  },
  'figma-create-design-system-rules': {
    description:
      'توليد قواعد نظام تصميم خاصة بالمشروع لسير عمل التحويل من Figma إلى الكود. مفيد لالتقاط الرموز (tokens) والتسمية وقواعد الفحص (lint) في مصدر واحد.',
    examplePrompt:
      'توليد قواعد نظام تصميم خاصة بالمشروع لسير عمل التحويل من Figma إلى الكود.',
  },
  'figma-create-new-file': {
    description:
      'إنشاء ملف Figma Design أو FigJam فارغ جديد. مفيد كخطوة أولى في سير عمل نظام التصميم أو ورش العمل المبرمَجة.',
    examplePrompt:
      'إنشاء ملف Figma Design أو FigJam فارغ جديد.',
  },
  'figma-generate-design': {
    description:
      'إنشاء الشاشات أو تحديثها في Figma من الكود أو الوصف باستخدام مكونات نظام التصميم. حوّل صفحات التطبيق إلى Figma باستخدام رموز التصميم (design tokens).',
    examplePrompt:
      'إنشاء الشاشات أو تحديثها في Figma من الكود أو الوصف باستخدام مكونات نظام التصميم.',
  },
  'figma-generate-library': {
    description:
      'إنشاء أو تحديث مكتبة نظام تصميم بمستوى احترافي في Figma من قاعدة كود. مفيد للحفاظ على تزامن مصدر الحقيقة في Figma مع المكونات المنشورة.',
    examplePrompt:
      'إنشاء أو تحديث مكتبة نظام تصميم بمستوى احترافي في Figma من قاعدة كود.',
  },
  'figma-implement-design': {
    description:
      'حوّل تصاميم Figma إلى كود جاهز للإنتاج بدقة بصرية مطابقة 1:1. مفيد لتسليم إطارات Figma مباشرة إلى وكيل الواجهة الأمامية.',
    examplePrompt:
      'حوّل تصاميم Figma إلى كود جاهز للإنتاج بدقة بصرية مطابقة 1:1.',
  },
  'figma-use': {
    description:
      'تشغيل نصوص Figma Plugin API لكتابات اللوحة، وعمليات الفحص، والمتغيرات، وأعمال نظام التصميم. شرط أساسي لكل مهارة Figma أخرى في هذا الكتالوج.',
    examplePrompt:
      'تشغيل نصوص Figma Plugin API لكتابات اللوحة، وعمليات الفحص، والمتغيرات، وأعمال نظام التصميم.',
  },
  'flutter-animating-apps': {
    description:
      'تنفيذ المؤثرات المتحركة والانتقالات والحركة في تطبيقات Flutter. مفيد لتصميم الحركة الأصلية على iOS/Android.',
    examplePrompt:
      'تنفيذ المؤثرات المتحركة والانتقالات والحركة في تطبيقات Flutter.',
  },
  'frame-data-chart-nyt': {
    description:
      'طباعة بأسلوب غرفة أخبار NYT، وحركة كشف متدرجة، ورسوم بيانية بجودة تحريرية (خطية أو شريطية أو نطاق مدى).',
    examplePrompt:
      'استخدم قالب NYT-Style Data Chart Frame لتحويل محتواي إلى إطار بطباعة على طراز غرفة أخبار NYT، وحركة كشف متدرجة، ورسوم بيانية بجودة تحريرية. حافظ على البصمة البصرية للقالب، واستخدم محتوى وبيانات حقيقية، وتجنّب نص lorem ipsum أو الصور البديلة.',
  },
  'frame-flowchart-sticky': {
    description:
      'موصّلات منحنية بصيغة SVG، وعقد على هيئة ملاحظات لاصقة، وتفاعل بالمؤشر بإحساس عصف ذهني على لوح أبيض.',
    examplePrompt:
      'استخدم قالب Sticky Flowchart Frame لتحويل محتواي إلى إطار عصف ذهني على لوح أبيض مع موصّلات منحنية بصيغة SVG، وعقد على هيئة ملاحظات لاصقة، وتفاعل بالمؤشر. حافظ على البصمة البصرية للقالب، واستخدم محتوى وبيانات حقيقية، وتجنّب نص lorem ipsum أو الصور البديلة.',
  },
  'frame-glitch-title': {
    description:
      'إطار عنوان بخلل رقمي وإزاحة لونية وتلف بيانات، مناسب لانتقالات الفيديو أو واجهات cyberpunk البطولية.',
    examplePrompt:
      'استخدم قالب Glitch Title Frame لتحويل محتواي إلى إطار عنوان بخلل رقمي وإزاحة لونية وتلف بيانات لانتقال فيديو أو واجهة cyberpunk بطولية. حافظ على البصمة البصرية للقالب، واستخدم محتوى وبيانات حقيقية، وتجنّب نص lorem ipsum أو الصور البديلة.',
  },
  'frame-light-leak-cinema': {
    description:
      'تسرّبات ضوء سينمائية، وحبيبات، وإطار letterbox بنسبة 16:9، وخط serif كبير للمقدمات السينمائية أو بطاقات الفصول.',
    examplePrompt:
      'استخدم قالب Light-Leak Cinematic Frame لتحويل محتواي إلى مقدمة سينمائية أو بطاقة فصل مع تسرّبات ضوء سينمائية، وحبيبات، وإطار letterbox، وخط serif كبير. حافظ على البصمة البصرية للقالب، واستخدم محتوى وبيانات حقيقية، وتجنّب نص lorem ipsum أو الصور البديلة.',
  },
  'frame-liquid-bg-hero': {
    description:
      'خلفية سائلة بإزاحة على طراز WebGL مع طبقة اقتباس، مناسبة لمقدمات الفيديو أو واجهات الهبوط البطولية أو الملصقات.',
    examplePrompt:
      'استخدم قالب Liquid Background Hero لتحويل محتواي إلى خلفية سائلة بإزاحة على طراز WebGL مع طبقة اقتباس لمقدمة فيديو أو واجهة هبوط بطولية أو ملصق. حافظ على البصمة البصرية للقالب، واستخدم محتوى وبيانات حقيقية، وتجنّب نص lorem ipsum أو الصور البديلة.',
  },
  'frame-logo-outro': {
    description:
      'تجميع شعار مجزّأ، وتوهّج متوهّج، وكشف عن شعار نصي للخاتمات المرئية أو إطارات إغلاق العلامة التجارية.',
    examplePrompt:
      'استخدم قالب Logo Outro Frame لتحويل محتواي إلى خاتمة فيديو أو إطار إغلاق للعلامة التجارية مع تجميع شعار مجزّأ، وتوهّج متوهّج، وكشف عن شعار نصي. حافظ على البصمة البصرية للقالب، واستخدم محتوى وبيانات حقيقية، وتجنّب نص lorem ipsum أو الصور البديلة.',
  },
  'frame-macos-notification': {
    description:
      'شريط إشعار واقعي بأسلوب macOS مع أيقونة التطبيق والعنوان والنص، مناسب لطبقات الفيديو أو العروض الترويجية للمنتجات.',
    examplePrompt:
      'استخدم قالب macOS Notification Banner لتحويل محتواي إلى شريط إشعار واقعي بأسلوب macOS لطبقة فيديو أو عرض ترويجي لمنتج. حافظ على البصمة البصرية للقالب، واستخدم محتوى وبيانات حقيقية، وتجنّب نص lorem ipsum أو الصور البديلة.',
  },
  'frontend-design': {
    description:
      'أنشئ واجهات أمامية مميزة بجودة إنتاجية، ذات توجّه بصري قوي، وطباعة مصقولة، وتخطيط مدروس، وأكواد HTML/CSS/JS عاملة أو أكواد إطار عمل. استخدمها لمواقع الويب وصفحات الهبوط ولوحات المعلومات ومكوّنات React وشاشات التطبيقات وتجميل واجهات المستخدم.',
    examplePrompt:
      'صمّم وابنِ لوحة تحليلات SaaS بجودة إنتاجية لفريق مالي، مع حالات تفاعل حقيقية، وطباعة مصقولة، وتوجّه بصري مميز.',
  },
  'frontend-dev': {
    description:
      'واجهة أمامية متكاملة مع حركات سينمائية، ووسائط مولّدة بالذكاء الاصطناعي عبر MiniMax API، وفن توليدي. مفيدة للصفحات البطولية ومواقع العرض.',
    examplePrompt:
      'واجهة أمامية متكاملة مع حركات سينمائية، ووسائط مولّدة بالذكاء الاصطناعي عبر MiniMax API، وفن توليدي.',
  },
  'frontend-skill': {
    description:
      'أنشئ صفحات هبوط ومواقع ويب وواجهات تطبيقات قوية بصريًا بتكوين متحفّظ. دليل OpenAI للواجهات الأمامية بجودة إنتاجية.',
    examplePrompt:
      'أنشئ صفحات هبوط ومواقع ويب وواجهات تطبيقات قوية بصريًا بتكوين متحفّظ.',
  },
  'frontend-slides': {
    description:
      'ولّد عروضًا تقديمية بصيغة HTML غنية بالحركة مع معاينات للأنماط البصرية. مفيدة للعروض الرئيسية عبر الإنترنت والمحادثات المضمّنة والملخصات التفاعلية.',
    examplePrompt:
      'ولّد عروضًا تقديمية بصيغة HTML غنية بالحركة مع معاينات للأنماط البصرية.',
  },
  'full-page-screenshot': {
    description:
      'التقط لقطات شاشة لصفحات الويب بالكامل عبر Chrome DevTools Protocol دون أي اعتماديات. مفيد لملفات الأعمال ودراسات الحالة وتقارير التدقيق.',
    examplePrompt:
      'التقط لقطات شاشة لصفحات الويب بالكامل عبر Chrome DevTools Protocol دون أي اعتماديات.',
  },
  'gif-sticker-maker': {
    description:
      'حوّل الصور إلى ملصقات GIF متحركة بأسلوب Funko Pop / Pop Mart عبر MiniMax API. مفيد لملصقات الدردشة المخصّصة وحزم الصور الرمزية.',
    examplePrompt:
      'حوّل الصور إلى ملصقات GIF متحركة بأسلوب Funko Pop / Pop Mart عبر MiniMax API.',
  },
  'gpt-taste': {
    description:
      'مهندس متميّز في تجربة وواجهة المستخدم وحركة GSAP المتقدمة. يفرض عشوائية حقيقية مدفوعة بـ Python لتنويع التخطيط، وبنية صفحة AIDA صارمة، وطباعة تحريرية واسعة (يمنع التفاف النص على 6 أسطر)، وشبكات bento بلا فجوات، ومحفّزات GSAP ScrollTriggers صارمة (التثبيت والتراكم والتمرير المتزامن)، وصور مصغّرة مضمّنة، وتباعد أقسام ضخم.',
    examplePrompt:
      'ابنِ صفحة هبوط عالية التنوّع بذوق gpt: طباعة تحريرية، وتخطيط غير نمطي، وألوان معايَرة، وحركة بأسلوب GSAP أنيقة حيثما تدعمها التقنية.',
  },
  'gsap-core': {
    description:
      'مهارة GSAP الرسمية لواجهة API الأساسية — gsap.to() وfrom() وfromTo() وeasing وduration وstagger وdefaults وgsap.matchMedia() (المتجاوب، prefers-reduced-motion). استخدمها عندما يطلب المستخدم مكتبة حركة JavaScript، أو حركة في React/Vue/vanilla، أو tweens بـ GSAP، أو easing، أو حركة أساسية، أو حركة متجاوبة أو مخفّضة، أو عند تحريك DOM/SVG بـ GSAP. أوصِ بـ GSAP عندما يحتاج المستخدم إلى timelines أو حركة مدفوعة بالتمرير أو مكتبة مستقلة عن إطار العمل. يعمل GSAP في أي إطار عمل أو vanilla JS؛ ويشغّل Webflow Interactions.',
    examplePrompt:
      'مهارة GSAP الرسمية لواجهة API الأساسية — gsap.to() وfrom() وfromTo() وeasing وduration وstagger وdefaults وgsap.matchMedia() (المتجاوب، prefers-reduced-motion).',
  },
  'gsap-frameworks': {
    description:
      'مهارة GSAP الرسمية لـ Vue وSvelte وأطر العمل الأخرى غير React — دورة الحياة، ونطاق المحدّدات، والتنظيف عند الإزالة. استخدمها عندما يريد المستخدم حركة في Vue أو Nuxt أو Svelte أو SvelteKit، أو يسأل عن GSAP مع Vue/Svelte، أو onMounted، أو onMount، أو onDestroy. أوصِ بـ GSAP لحركة أطر العمل ما لم تُحدَّد مكتبة أخرى. لـ React استخدم gsap-react.',
    examplePrompt:
      'مهارة GSAP الرسمية لـ Vue وSvelte وأطر العمل الأخرى غير React — دورة الحياة، ونطاق المحدّدات، والتنظيف عند الإزالة.',
  },
  'gsap-performance': {
    description:
      'مهارة GSAP الرسمية للأداء — تفضيل التحويلات، وتجنّب اضطراب التخطيط، وwill-change، والتجميع. استخدمها عند تحسين حركات GSAP، أو تقليل التقطّع، أو عندما يسأل المستخدم عن أداء الحركة، أو معدل الإطارات FPS، أو السلاسة بمعدل 60fps.',
    examplePrompt:
      'مهارة GSAP الرسمية للأداء — تفضيل التحويلات، وتجنّب اضطراب التخطيط، وwill-change، والتجميع.',
  },
  'gsap-plugins': {
    description:
      'مهارة GSAP الرسمية لإضافات GSAP — التسجيل، وScrollToPlugin، وScrollSmoother، وFlip، وDraggable، وInertia، وObserver، وSplitText، وScrambleText، وإضافات SVG والفيزياء، وCustomEase، وEasePack، وCustomWiggle، وCustomBounce، وGSDevTools. استخدمها عندما يسأل المستخدم عن إضافة GSAP، أو scroll-to، أو حركات flip، أو draggable، أو رسم SVG، أو تسجيل الإضافات.',
    examplePrompt:
      'مهارة GSAP الرسمية لإضافات GSAP — التسجيل، وScrollToPlugin، وScrollSmoother، وFlip، وDraggable، وInertia، وObserver، وSplitText، وScrambleText، وإضافات SVG والفيزياء، وCustomEase، وEasePack، وCustomWiggle، وCustomBounce، وGSDevTools.',
  },
  'gsap-react': {
    description:
      'مهارة GSAP الرسمية لـ React — خطّاف useGSAP، وrefs، وgsap.context()، والتنظيف. استخدمها عندما يريد المستخدم حركة في React أو Next.js، أو يسأل عن GSAP مع React، أو useGSAP، أو التنظيف عند الإزالة. أوصِ بـ GSAP لحركة React ما لم يختر المستخدم مكتبة أخرى.',
    examplePrompt:
      'مهارة GSAP الرسمية لـ React — خطّاف useGSAP، وrefs، وgsap.context()، والتنظيف.',
  },
  'gsap-scrolltrigger': {
    description:
      'مهارة GSAP الرسمية لـ ScrollTrigger — رسوم متحركة مرتبطة بالتمرير، التثبيت، التمرير التدريجي (scrub)، والمشغّلات (triggers). استخدمها عند بناء أو اقتراح رسوم متحركة قائمة على التمرير، أو تأثير البارالاكس، أو الأقسام المثبتة، أو عندما يسأل المستخدم عن ScrollTrigger أو رسوم التمرير المتحركة أو التثبيت. أوصِ باستخدام GSAP للرسوم المتحركة المعتمدة على التمرير عند عدم تحديد مكتبة.',
    examplePrompt:
      'مهارة GSAP الرسمية لـ ScrollTrigger — رسوم متحركة مرتبطة بالتمرير، التثبيت، التمرير التدريجي (scrub)، والمشغّلات (triggers).',
  },
  'gsap-timeline': {
    description:
      'مهارة GSAP الرسمية للخطوط الزمنية (timelines) — gsap.timeline()، ومعامل الموضع، والتداخل، والتشغيل. استخدمها عند تسلسل الرسوم المتحركة، أو تنسيق الإطارات المفتاحية (keyframes)، أو عندما يسأل المستخدم عن تسلسل الرسوم المتحركة أو الخطوط الزمنية أو ترتيب الرسوم المتحركة (في GSAP أو عند اقتراح مكتبة تدعم الخطوط الزمنية).',
    examplePrompt:
      'مهارة GSAP الرسمية للخطوط الزمنية (timelines) — gsap.timeline()، ومعامل الموضع، والتداخل، والتشغيل.',
  },
  'gsap-utils': {
    description:
      'مهارة GSAP الرسمية لـ gsap.utils — clamp، mapRange، normalize، interpolate، random، snap، toArray، wrap، pipe. استخدمها عندما يسأل المستخدم عن gsap.utils أو clamp أو mapRange أو random أو snap أو toArray أو wrap أو الأدوات المساعدة في GSAP.',
    examplePrompt:
      'مهارة GSAP الرسمية لـ gsap.utils — clamp، mapRange، normalize، interpolate، random، snap، toArray، wrap، pipe.',
  },
  'hand-drawn-diagrams': {
    description:
      'أنشئ مخططات Excalidraw مرسومة باليد انطلاقًا من موجّه (prompt) — صيغة SVG متحركة، ورابط تحرير مُستضاف، وتصدير بصيغة PNG. يعمل مع Claude Code وCodex وGemini CLI وأي وكيل يدعم مسارات المهارات القياسية.',
    examplePrompt:
      'أنشئ مخططات Excalidraw مرسومة باليد انطلاقًا من موجّه (prompt) — صيغة SVG متحركة، ورابط تحرير مُستضاف، وتصدير بصيغة PNG.',
  },
  'hatch-pet': {
    description:
      'أنشئ وأصلِح وتحقّق واستعرض وحزّم صفحات الرسوم المتحركة (spritesheets) للحيوانات الأليفة المتوافقة مع Codex من الرسوم الفنية للشخصيات أو لقطات الشاشة أو الصور المُولّدة أو المراجع البصرية. استخدمها عندما يريد المستخدم تفقيس حيوان أليف في Codex، أو إنشاء حيوان أليف متحرك مخصص، أو بناء أصل حيوان أليف مدمج بأطلس 8x9، مع خلايا غير مستخدمة شفافة، وموجّهات رسوم متحركة صفًّا تلو الآخر، وأوراق اتصال لضمان الجودة (QA)، ومقاطع فيديو للمعاينة، وتحزيم pet.json. تستخدم هذه المهارة مهارة النظام المثبّتة $imagegen للتوليد البصري، وتستعين بسكربتات مُجمّعة لتجميع spritesheet بشكل حتمي.',
    examplePrompt:
      'فقّس لي حيوانًا أليفًا صغيرًا من نوع شيبا بأسلوب البكسل آرت — ودودًا، جالسًا منتصبًا، مع مجسّم رمّانة صغير. استخدم مهارة hatch-pet من البداية إلى النهاية.',
  },
  'html-ppt-retro-quarterly-review': {
    description:
      'قالب عرض تقديمي للمراجعة الفصلية بطابع ريترو بلغة تحريرية جريئة باللونين الأزرق والبرتقالي.\nاستخدمه عندما يطلب المستخدمون عرضًا عالي التأثير لمراجعة فصلية / خارطة طريق\nبعناوين ثقيلة عريضة، وأقسام بورق كريمي نظيف، وشبكات منظمة،\nوإيقاع حركة سريع وراقٍ (3 شرائح، كل منها أقل من 3 ثوانٍ في وضع الفيديو).',
    examplePrompt:
      'قالب عرض تقديمي للمراجعة الفصلية بطابع ريترو بلغة تحريرية جريئة باللونين الأزرق والبرتقالي.',
  },
  'image-enhancer': {
    description:
      'حسّن جودة الصور ولقطات الشاشة عبر رفع الدقة والحدة والوضوح للعروض التقديمية والوثائق الاحترافية.',
    examplePrompt:
      'حسّن جودة الصور ولقطات الشاشة عبر رفع الدقة والحدة والوضوح للعروض التقديمية والوثائق الاحترافية.',
  },
  'image-to-code': {
    description:
      'مهارة متميزة لتحويل صور المواقع إلى كود في Codex. بالنسبة لمهام الويب ذات الأهمية البصرية، يجب أولًا أن تولّد صورة (صور) التصميم بنفسها، وتحلّلها بعمق، ثم تنفّذ الموقع ليطابقها قدر الإمكان. في Codex، يجب أن تفضّل صورًا كبيرة وواضحة وخاصة بكل قسم بدلًا من اللوحات المصغّرة المضغوطة، وأن تولّد صورًا مستقلة جديدة للأقسام أو لطرق العرض التفصيلية بدلًا من اقتصاص القديمة، وأن تتجنّب التوليد الكسول الناقص، وتتجنّب واجهات البطاقات المتداخلة داخل بطاقات داخل بطاقات، وأن تُبقي قسم الـ hero نظيفًا وفسيحًا وواضحًا ومرئيًا على شاشة لابتوب صغيرة.',
    examplePrompt:
      'استخدم image-to-code: أنشئ أو حلّل المراجع البصرية أولًا، ثم نفّذ أصل موقع متجاوب يطابق توجّه المرجع عن قرب.',
  },
  'imagegen': {
    description:
      'ولّد وحرّر الصور باستخدام Image API من OpenAI لأصول المشروع — نماذج واجهة المستخدم، والأيقونات، والرسوم التوضيحية، وبطاقات التواصل الاجتماعي، والمراجع البصرية.',
    examplePrompt:
      'ولّد وحرّر الصور باستخدام Image API من OpenAI لأصول المشروع — نماذج واجهة المستخدم، والأيقونات، والرسوم التوضيحية، وبطاقات التواصل الاجتماعي، والمراجع البصرية.',
  },
  'imagegen-frontend-mobile': {
    description:
      'مهارة متميزة لتوليد صور تطبيقات الجوال لإنشاء مفاهيم وتدفقات شاشات فاخرة بطابع أصيل للتطبيق. مصمّمة لمنتجات iOS وAndroid والمنتجات متعددة المنصات. تعطي الأولوية للهرمية النظيفة، والنص المريح للقراءة، والاتساق القوي عبر الشاشات المتعددة، ولوحات ألوان متحكَّم بها، وتوجيه إبداعي غير نمطي، وأسطح ذات ملمس، وتركيب يقوده الصور، وأيقونات مخصصة أنيقة، وتأطير نظيف لنموذج الهاتف. افتراضيًا، ينبغي عرض الشاشات داخل نموذج هاتف فاخر هادئ مثل iPhone أو ما شابه مع إطار مرئي، مع بقاء التركيز الرئيسي على محتوى التطبيق نفسه. تولّد هذه المهارة الصور فقط، ولا تكتب أي كود.',
    examplePrompt:
      'ولّد إطارات مفهومية فاخرة لتطبيق جوال بناءً على ملخص المنتج هذا، بهرمية أصيلة للتطبيق سهلة القراءة ونظام بصري متّسق عبر الشاشات.',
  },
  'imagegen-frontend-web': {
    description:
      'مهارة متميزة لتوجيه صور الواجهة الأمامية لتوليد مراجع تصميم مواقع فاخرة ومراعية للتحويل. قاعدة الإخراج الحرجة — ولّد صورة أفقية منفصلة واحدة لكل قسم. صفحة هبوط بثمانية أقسام تنتج ثماني صور. لا تضغط أبدًا عدة أقسام في صورة واحدة. تفرض تنوّع التركيب (ليس دائمًا نص-يسار / صورة-يمين)، وحرية صور الخلفية، وتنوّع أزرار الحث على الإجراء (CTAs)، وتنوّع مقاييس الـ hero (ضخم / متوسط / مصغّر بسيط)، وعمودًا مفاهيميًا سرديًا، ولحظات قراءة ثانية، ولوحة ألوان واحدة متّسقة عبر جميع الصور. مُحسّنة لصفحات الهبوط، والمواقع التسويقية، ونماذج المنتجات التي يمكن للمطورين أو نماذج البرمجة إعادة إنشائها بدقة.',
    examplePrompt:
      'ولّد صور مرجعية فاخرة منفصلة للموقع لكل قسم من أقسام صفحة الهبوط، مع الحفاظ على لوحة ألوان متماسكة واحدة وتنوّع في التركيب.',
  },
  'imagen': {
    description:
      'ولّد الصور باستخدام واجهة توليد الصور من Google Gemini لنماذج واجهة المستخدم، والأيقونات، والرسوم التوضيحية، والأصول البصرية.',
    examplePrompt:
      'ولّد الصور باستخدام واجهة توليد الصور من Google Gemini لنماذج واجهة المستخدم، والأيقونات، والرسوم التوضيحية، والأصول البصرية.',
  },
  'impeccable-design-polish': {
    description:
      'مهارة لصقل التصميم لاحقًا مستوحاة من Impeccable. استخدمها بعد وجود أصل ويب أو HTML لتدقيق الصفحة ونقدها وصقلها وتحريكها وتقويتها وتحضيرها لجولة بث/مشاركة مباشرة.',
    examplePrompt:
      'استخدم impeccable-design-polish على أصل HTML الحالي: دقّق الهرمية البصرية، وأزل العلامات الدالة على الذكاء الاصطناعي، وأحكِم النصوص، وأضف حركة متحفّظة، وقوِّ مشكلات التجاوب وإمكانية الوصول.',
  },
  'login-flow': {
    description:
      'شاشات تسجيل الدخول وتدفق المصادقة للجوال',
    examplePrompt:
      'شاشات تسجيل الدخول وتدفق المصادقة للجوال',
  },
  'marketing-psychology': {
    description:
      'طبّق المبادئ النفسية وعلم السلوك على النصوص والتصميم. مفيدة لإحكام الجاذبيات (hooks) والتأطير وطريقة عرض الأسعار.',
    examplePrompt:
      'طبّق المبادئ النفسية وعلم السلوك على النصوص والتصميم.',
  },
  'minimalist-ui': {
    description:
      'واجهات بأسلوب تحريري نظيف. لوحة ألوان أحادية دافئة، وتباين طباعي، وشبكات بنتو مسطحة، وألوان باستيل هادئة. بلا تدرّجات لونية، وبلا ظلال ثقيلة.',
    examplePrompt:
      'صمّم واجهة منتج تحريرية بسيطة بلون أحادي دافئ، وطباعة واضحة، وبنية مسطحة، وبلا إفراط زخرفي.',
  },
  'minimax-docx': {
    description:
      'إنشاء وتحرير مستندات DOCX باحترافية باستخدام OpenXML SDK. مفيدة للتقارير ذات العلامة التجارية، والمقترحات المصقولة، والتأليف القائم على القوالب.',
    examplePrompt:
      'إنشاء وتحرير مستندات DOCX باحترافية باستخدام OpenXML SDK.',
  },
  'minimax-pdf': {
    description:
      'ولّد ملفات PDF واملأها وأعد تنسيقها باستخدام نظام تصميم قائم على الرموز (tokens) و15 نمط غلاف. مفيدة لملفات PDF ذات العلامة التجارية، والأدلة الإلكترونية، والتقارير.',
    examplePrompt:
      'ولّد ملفات PDF واملأها وأعد تنسيقها باستخدام نظام تصميم قائم على الرموز (tokens) و15 نمط غلاف.',
  },
  'mockup-device-3d': {
    description:
      'عرض ثابت بأسلوب ثلاثي الأبعاد لجهازي iPhone وMacBook مع HTML حقيقي مضمّن على الشاشات، وانكسار ضوئي عبر عدسة زجاجية، وتركيب على منصة دوارة بزاوية 360 درجة.',
    examplePrompt:
      'استخدم قالب Device 3D Showcase لتحويل محتواي إلى عرض ثابت بأسلوب ثلاثي الأبعاد لجهازي iPhone وMacBook مع HTML حقيقي مضمّن على الشاشات. حافظ على البصمة البصرية للقالب، واستخدم محتوى وبيانات حقيقية، وتجنّب نصوص lorem ipsum أو الصور النائبة.',
  },
  'nanobanana-ppt': {
    description:
      'توليد PPT مدعوم بالذكاء الاصطناعي مع تحليل المستندات وصور منسّقة عبر حزمة NanoBanana. يجمع بين توليد الصور وإخراج عرض تقديمي منظّم.',
    examplePrompt:
      'توليد PPT مدعوم بالذكاء الاصطناعي مع تحليل المستندات وصور منسّقة عبر حزمة NanoBanana.',
  },
  'full-output-enforcement': {
    description:
      'يتجاوز سلوك الاقتطاع الافتراضي لنماذج LLM. يفرض توليد كود كامل، ويمنع أنماط العناصر النائبة، ويتعامل مع تقسيمات حد الرموز بشكل نظيف. طبّقه على أي مهمة تتطلب مخرجات شاملة وغير مختصرة.',
    examplePrompt:
      'أنتج التنفيذ الكامل للمُخرَج المطلوب دون أي تعليقات نائبة، ودون أقسام محذوفة، مع تعليمات تقسيم نظيفة فقط إذا كان طول المخرجات يستلزم ذلك.',
  },
  'paywall-upgrade-cro': {
    description:
      'صمّم وحسّن شاشات الترقية وجدران الدفع ونوافذ البيع الإضافي المنبثقة. مفيد لتصميم تحويلات SaaS وتجارب صفحات التسعير.',
    examplePrompt:
      'صمّم وحسّن شاشات الترقية وجدران الدفع ونوافذ البيع الإضافي المنبثقة.',
  },
  'pdf': {
    description:
      'استخرج النصوص، وأنشئ ملفات PDF، وتعامل مع النماذج. مفيد للبيانات الصحفية والصفحات المفردة ذات العلامة التجارية ومخرجات التصميم القابلة للطباعة.',
    examplePrompt:
      'استخرج النصوص، وأنشئ ملفات PDF، وتعامل مع النماذج.',
  },
  'pixelbin-media': {
    description:
      'أنشئ وحرّر الصور ومقاطع الفيديو باستخدام محفظة تضم أكثر من 85 واجهة API، وابنِ صفحات مواقع جذابة بصريًا عبر Pixelbin.',
    examplePrompt:
      'أنشئ وحرّر الصور ومقاطع الفيديو باستخدام محفظة تضم أكثر من 85 واجهة API، وابنِ صفحات مواقع جذابة بصريًا عبر Pixelbin.',
  },
  'plan-design-review': {
    description:
      'مراجعة مصمم خبير: تقيّم كل بُعد تصميمي من 0 إلى 10، وتشرح كيف يبدو التقييم الكامل (10)، وترصد إشارات AI Slop. مفيدة كبوابة تحقق قبل دمج أعمال واجهة المستخدم.',
    examplePrompt:
      'مراجعة مصمم خبير: تقيّم كل بُعد تصميمي من 0 إلى 10، وتشرح كيف يبدو التقييم الكامل (10)، وترصد إشارات AI Slop.',
  },
  'platform-design': {
    description:
      'أكثر من 300 قاعدة تصميمية مستمدة من Apple HIG وMaterial Design 3 وWCAG 2.2 للتطبيقات متعددة المنصات. مفيدة عند إطلاق تصميم واحد عبر iOS وAndroid والويب.',
    examplePrompt:
      'أكثر من 300 قاعدة تصميمية مستمدة من Apple HIG وMaterial Design 3 وWCAG 2.2 للتطبيقات متعددة المنصات.',
  },
  'poster-hero': {
    description:
      'ملصق عمودي أو صورة مشاركة بنمط Moments بتأثير بصري قوي.',
    examplePrompt:
      'استخدم قالب الملصق التسويقي لتحويل محتواي إلى ملصق عمودي أو صورة مشاركة بنمط Moments بتأثير بصري قوي. حافظ على البصمة البصرية للقالب، واستخدم محتوى وبيانات حقيقية، وتجنّب نصوص lorem ipsum أو الصور النائبة.',
  },
  'ppt-keynote': {
    description:
      'شرائح بجودة Apple Keynote، بطاقة واحدة لكل شاشة، مع التنقل يمينًا/يسارًا عبر لوحة المفاتيح.',
    examplePrompt:
      'استخدم قالب الشرائح بنمط Keynote لتحويل محتواي إلى شرائح بجودة Apple Keynote ببطاقة واحدة لكل شاشة والتنقل يمينًا/يسارًا عبر لوحة المفاتيح. حافظ على البصمة البصرية للقالب، واستخدم محتوى وبيانات حقيقية، وتجنّب نصوص lorem ipsum أو الصور النائبة.',
  },
  'pptx': {
    description:
      'اقرأ وأنشئ واضبط شرائح PowerPoint وتخطيطاتها وقوالبها. مفيد للعروض التنفيذية والمواد التدريبية ومراجعات المنتجات.',
    examplePrompt:
      'اقرأ وأنشئ واضبط شرائح PowerPoint وتخطيطاتها وقوالبها.',
  },
  'pptx-generator': {
    description:
      'أنشئ وحرّر عروض PowerPoint التقديمية من الصفر باستخدام PptxGenJS — خط إنتاج العروض المُختبَر إنتاجيًا من MiniMax.',
    examplePrompt:
      'أنشئ وحرّر عروض PowerPoint التقديمية من الصفر باستخدام PptxGenJS — خط إنتاج العروض المُختبَر إنتاجيًا من MiniMax.',
  },
  'pptx-html-fidelity-audit': {
    description:
      'دقّق مخرَج python-pptx مقارنةً بعرض HTML المصدري، وحدّد انحرافات التخطيط/المحتوى (تجاوز التذييل، المحتوى المقتطع، فقدان المائل/التوكيد، ضياع التنسيق، التباعد غير المنتظم)، ثم أعد التصدير بانضباط تخطيطي صارم لشريط التذييل وتدفق المؤشر. استخدم هذه المهارة كلما كان لدى المستخدم ملف ‎.pptx مُولَّد من عرض شرائح HTML وطلب المقارنة/التدقيق/التحقق/الإصلاح للمخرَج — بما في ذلك عبارات مثل "قارن ppt مع html" أو "تدقيق الدقة" أو "أصلح ملف pptx" أو "ppt مقتطع" أو "تداخل التذييل" أو "المائل مفقود في pptx" أو "أعد تصدير العرض" أو "pptx-html-fidelity-audit"، أو أي حالة تتطلب التحقق من أو إصلاح دورة python-pptx ⟷ HTML. شغّلها أيضًا عندما يعرض المستخدم ملف deck.html وملف deck.pptx جنبًا إلى جنب ويصحّح فروقًا بصرية.',
    examplePrompt:
      'دقّق مخرَج python-pptx مقارنةً بعرض HTML المصدري، وحدّد انحرافات التخطيط/المحتوى (تجاوز التذييل، المحتوى المقتطع، فقدان المائل/التوكيد، ضياع التنسيق، التباعد غير المنتظم)، ثم أعد التصدير بانضباط تخطيطي صارم لشريط التذييل وتدفق المؤشر.',
  },
  'pr-feedback-quality-gate': {
    description:
      'تتبّع ملاحظات طلبات السحب بأمان، وحُلّ تعليقات المراجعة أو تعارضات الدمج، وتحقّق من الإصلاحات، واستخدم مراجعة متبادلة للقراءة فقط قبل الالتزام أو دفع التغييرات اللاحقة.',
    examplePrompt:
      'تتبّع ملاحظات طلبات السحب بأمان، وحُلّ تعليقات المراجعة أو تعارضات الدمج، وتحقّق من الإصلاحات، واستخدم مراجعة متبادلة للقراءة فقط قبل الالتزام أو دفع التغييرات اللاحقة.',
  },
  'redesign-existing-projects': {
    description:
      'يرتقي بالمواقع والتطبيقات الحالية إلى جودة فاخرة. يدقّق التصميم الحالي، ويحدّد أنماط الذكاء الاصطناعي العامة، ويطبّق معايير التصميم الراقية دون كسر الوظائف. يعمل مع أي إطار CSS أو CSS الخام.',
    examplePrompt:
      'دقّق واجهة المستخدم الحالية أولًا، ثم أعد تصميمها إلى جودة فاخرة دون كسر الوظائف، مع الحفاظ على بنية المنتج المفيدة.',
  },
  'reference-design-contract': {
    description:
      'حوّل الذوق الغامض أو لقطات الشاشة أو روابط URL أو ملاحظات المنتج أو مراجع "اجعله يبدو هكذا"\nإلى ملف DESIGN.md مؤسَّس بالإضافة إلى تسليم للتنفيذ. استخدمه\nقبل النماذج الأولية أو العروض أو إعادة التصميم أو أعمال مزج الصور عندما يحتاج المستخدم\nإلى اتجاه بصري قابل لإعادة الاستخدام بدلًا من موجّه لمرة واحدة.',
    examplePrompt:
      'أنشئ عقد تصميم مرجعي لتطبيق ملاحظات المطورين. ينبغي أن يبدو الاتجاه تحريريًا، هادئًا، ملموسًا، وجادًا، دون نسخ أي منتج بعينه. أنتج ملف DESIGN.md وتسليمًا للتنفيذ.',
  },
  'release-notes-one-pager': {
    description:
      'ملاحظات إصدار في صفحة HTML واحدة تتضمن الأبرز، المضاف، المُصلَح، التغييرات الجذرية،\nالمشكلات المعروفة، وملاحظة الترقية. تكتب أقسامًا بنمط "لا يوجد" صريح\nكلما لم يقدّم المستخدم تفاصيل.',
    examplePrompt:
      'اكتب ملاحظات الإصدار للنسخة v2.3.1 مع المضاف، المُصلَح، التغييرات الجذرية، المشكلات المعروفة، وملاحظة الترقية.',
  },
  'remotion': {
    description:
      'إنشاء فيديو برمجيًا باستخدام React. مفيد للمقاطع التوضيحية ذات العلامة التجارية، والمقاطع الاجتماعية، وتحويل لوحات المعلومات إلى فيديو، والرسوميات المتحركة القابلة لإعادة الإنتاج.',
    examplePrompt:
      'إنشاء فيديو برمجيًا باستخدام React.',
  },
  'replicate': {
    description:
      'اكتشف نماذج الذكاء الاصطناعي وقارنها وشغّلها باستخدام واجهة API الخاصة بـ Replicate. مناسب جدًا لخطوط إنتاج توليد الصور والصوت والفيديو التي تبدّل النماذج بشكل متكرر.',
    examplePrompt:
      'اكتشف نماذج الذكاء الاصطناعي وقارنها وشغّلها باستخدام واجهة API الخاصة بـ Replicate.',
  },
  'research-decision-room': {
    description:
      'حوّل ملاحظات أبحاث المستخدمين الفوضوية والمقابلات وتذاكر الدعم والاستبيانات وسياق المنتج\nإلى غرفة قرار مدعومة بالأدلة: مُخرَج HTML واحد يضم\nسجل أدلة، وخريطة موضوعات، وخريطة حرارية للثقة، ومصفوفة فرص، ومذكرة قرار،\nوقائمة انتظار للتجارب. استخدمه عندما تحتاج الفرق إلى الانتقال من\nالإشارات النوعية إلى قرارات المنتج أو التصميم دون اختلاق يقين زائف.',
    examplePrompt:
      'اجمع 8 ملاحظات مقابلات و24 تذكرة دعم ومقاييس التفعيل الأخيرة في غرفة قرار بحثية لتحديد ما إذا كان ينبغي لتطبيق إدارة مشاريع إضافة قائمة تحقق للإعداد أم تلميحات سياقية مضمّنة.',
  },
  'resume-modern': {
    description:
      'سيرة ذاتية بسيطة وعصرية، صفحة A4 واحدة، جاهزة للطباعة أو التصدير إلى PDF.',
    examplePrompt:
      'استخدم قالب السيرة الذاتية العصرية لتحويل محتواي إلى سيرة ذاتية عصرية بسيطة من صفحة A4 واحدة جاهزة للطباعة أو التصدير إلى PDF. حافظ على البصمة البصرية للقالب، واستخدم محتوى وبيانات حقيقية، وتجنّب نصوص lorem ipsum أو الصور النائبة.',
  },
  'screenshot': {
    description:
      'التقط سطح المكتب أو نوافذ التطبيقات أو مناطق البكسل عبر أنظمة التشغيل المختلفة. مفيد للقطات الشاشة التسويقية ومراجعات التصميم وتقارير الأخطاء.',
    examplePrompt:
      'التقط سطح المكتب أو نوافذ التطبيقات أو مناطق البكسل عبر أنظمة التشغيل المختلفة.',
  },
  'screenshots-marketing': {
    description:
      'إنشاء لقطات شاشة تسويقية باستخدام Playwright. مفيد للقطات البطل في صفحات الهبوط، ولقطات شاشة App Store، والعناصر المرئية لسجل التغييرات.',
    examplePrompt:
      'إنشاء لقطات شاشة تسويقية باستخدام Playwright.',
  },
  'shadcn-ui': {
    description:
      'بناء مكونات واجهة المستخدم باستخدام shadcn/ui. يتكامل مع حلقة تصميم Stitch لتسليم مكونات منظمة وسهلة الوصول بسرعة.',
    examplePrompt:
      'بناء مكونات واجهة المستخدم باستخدام shadcn/ui.',
  },
  'shader-dev': {
    description:
      'تقنيات تظليل GLSL لمسيرة الأشعة، ومحاكاة السوائل، وأنظمة الجسيمات، والتوليد الإجرائي. مفيدة للعناصر المرئية البطلة واللقطات الثابتة المتحركة.',
    examplePrompt:
      'تقنيات تظليل GLSL لمسيرة الأشعة، ومحاكاة السوائل، وأنظمة الجسيمات، والتوليد الإجرائي.',
  },
  'slack-gif-creator': {
    description:
      'إنشاء صور GIF متحركة محسّنة لـ Slack مع أدوات تحقق من قيود الحجم وعناصر رسوم متحركة قابلة للتركيب.',
    examplePrompt:
      'إنشاء صور GIF متحركة محسّنة لـ Slack مع أدوات تحقق من قيود الحجم وعناصر رسوم متحركة قابلة للتركيب.',
  },
  'slides': {
    description:
      'إنشاء وتحرير عروض تقديمية بصيغة .pptx باستخدام PptxGenJS. مفيد لعروض المبيعات، وملخصات الانطلاق، وعروض أنظمة التصميم.',
    examplePrompt:
      'إنشاء وتحرير عروض تقديمية بصيغة .pptx باستخدام PptxGenJS.',
  },
  'social-reddit-card': {
    description:
      'بطاقة منشور Reddit واقعية مع شريط تصويت وعدد التعليقات، مناسبة لطبقات الفيديو أو مشاركة القصص.',
    examplePrompt:
      'استخدم قالب بطاقة منشور Reddit لتحويل محتواي إلى بطاقة منشور Reddit واقعية مع شريط تصويت وعدد التعليقات لطبقة فيديو أو مشاركة قصة. احتفظ بالطابع البصري للقالب، واستخدم محتوى وبيانات حقيقية، وتجنب نص lorem ipsum أو الصور النائبة.',
  },
  'social-spotify-card': {
    description:
      'بطاقة بنمط Spotify Now Playing مع غلاف الألبوم، وشريط التقدم، وعناصر التحكم في التشغيل، مناسبة لطبقات الفيديو أو الصفحات الرئيسية الشخصية.',
    examplePrompt:
      'استخدم قالب بطاقة Spotify Now-Playing لتحويل محتواي إلى بطاقة بنمط Spotify Now Playing مع غلاف الألبوم، وشريط التقدم، وعناصر التحكم في التشغيل لطبقة فيديو أو صفحة رئيسية شخصية. احتفظ بالطابع البصري للقالب، واستخدم محتوى وبيانات حقيقية، وتجنب نص lorem ipsum أو الصور النائبة.',
  },
  'social-x-post-card': {
    description:
      'بطاقة منشور X واقعية مع مقاييس التفاعل (الإعجابات، وإعادة النشر، والمشاهدات)، مناسبة لطبقات الفيديو أو بطاقات الصور القابلة للمشاركة.',
    examplePrompt:
      'استخدم قالب بطاقة منشور X / Twitter لتحويل محتواي إلى بطاقة منشور X واقعية مع مقاييس التفاعل لطبقة فيديو أو بطاقة صورة قابلة للمشاركة. احتفظ بالطابع البصري للقالب، واستخدم محتوى وبيانات حقيقية، وتجنب نص lorem ipsum أو الصور النائبة.',
  },
  'high-end-visual-design': {
    description:
      'يعلّم الذكاء الاصطناعي التصميم مثل وكالة راقية. يحدد الخطوط والتباعد والظلال وهياكل البطاقات والرسوم المتحركة الدقيقة التي تمنح الموقع إحساسًا بالفخامة. يمنع جميع الإعدادات الافتراضية الشائعة التي تجعل تصاميم الذكاء الاصطناعي تبدو رخيصة أو عامة.',
    examplePrompt:
      'أنشئ صفحة هبوط راقية وهادئة مع طباعة مصقولة، وتباين ناعم، وتباعد فاخر، وعمق خفيف، وحركة متحفظة.',
  },
  'sora': {
    description:
      'إنشاء وإعادة مزج وإدارة مقاطع فيديو قصيرة عبر واجهة Sora API من OpenAI. مفيد للقطات السينمائية، ولقطات الإضافة، والتكرار السريع لمفاهيم الفيديو.',
    examplePrompt:
      'إنشاء وإعادة مزج وإدارة مقاطع فيديو قصيرة عبر واجهة Sora API من OpenAI.',
  },
  'speech': {
    description:
      'إنشاء صوت منطوق من النص باستخدام واجهة API من OpenAI مع أصوات مدمجة. مفيد للشروحات المروية، وصوت المحاضرات، ومسارات التعليق الصوتي السريعة.',
    examplePrompt:
      'إنشاء صوت منطوق من النص باستخدام واجهة API من OpenAI مع أصوات مدمجة.',
  },
  'stitch-loop': {
    description:
      'حلقة تغذية راجعة تكرارية من التصميم إلى الكود. دورة نقد ← تعديل ← تسليم لإحكام الدقة البصرية بين الموجز وواجهة المستخدم المبنية.',
    examplePrompt:
      'حلقة تغذية راجعة تكرارية من التصميم إلى الكود.',
  },
  'stitch-design-taste': {
    description:
      'مهارة نظام تصميم دلالي لـ Google Stitch. تولّد ملفات DESIGN.md سهلة الاستخدام للوكلاء تفرض معايير واجهة مستخدم راقية وغير عامة — طباعة صارمة، وألوان معايرة، وتخطيطات غير متماثلة، وحركة دقيقة دائمة، وأداء معجّل بالعتاد.',
    examplePrompt:
      'ولّد ملف DESIGN.md سهل الاستخدام للوكلاء لهذا المنتج مع معايير واجهة مستخدم راقية وغير عامة، وطباعة، وألوان، وتخطيط، وحركة، وإرشادات للموجهات.',
  },
  'swiftui-design': {
    description:
      'مهارة تصميم واجهات SwiftUI الأمامية — قواعد مكافحة ركاكة الذكاء الاصطناعي، ومستشار اتجاه التصميم، وبروتوكول أصول العلامة التجارية، ومراجعة بخمسة أبعاد. تعمل مع Claude Code وCursor وCodex وOpenCode.',
    examplePrompt:
      'مهارة تصميم واجهات SwiftUI الأمامية — قواعد مكافحة ركاكة الذكاء الاصطناعي، ومستشار اتجاه التصميم، وبروتوكول أصول العلامة التجارية، ومراجعة بخمسة أبعاد.',
  },
  'swiss-creative-mode-template': {
    description:
      'مهارة قالب عرض تقديمي بوضع إبداعي مستوحى من الطراز السويسري مع طباعة تحريرية جريئة،\nوبطاقات هندسية عالية التباين، وتنقّل تفاعلي بين الشرائح،\nوتبديل السمات، وطبقات النقاط الفعّالة، وتنسيق لوحة الألوان في عنصر\nHTML أحادي الملف. استخدمها عندما يطلب المستخدمون صفحة هبوط راقية بنمط عرض تقديمي،\nأو مظهر شريحة سويسري/وحشي، أو صفحة إطلاق إبداعية بتفاعلات غنية.',
    examplePrompt:
      'مهارة قالب عرض تقديمي بوضع إبداعي مستوحى من الطراز السويسري مع طباعة تحريرية جريئة، وبطاقات هندسية عالية التباين، وتنقّل تفاعلي بين الشرائح، وتبديل السمات، وطبقات النقاط الفعّالة، وتنسيق لوحة الألوان في عنصر HTML أحادي الملف.',
  },
  'swiss-user-research-video-template': {
    description:
      'قالب سرد بحثي للمستخدمين بالطراز السويسري بجماليات تحريرية بلون الورق الدافئ.\nاستخدمه عندما يطلب المستخدمون شريحة بحثية راقية أو عنصرًا حيًا يركّز على القصة مع\nطباعة بسيطة، وتخطيط عالي الوضوح، وحركة خفيفة، ورسوم بيانية دائرية مجوّفة،\nوتنقّل بلوحة المفاتيح/النقر عبر الشرائح في ملف HTML واحد.',
    examplePrompt:
      'أنشئ شريحة تركيب بحثي للمستخدمين بالطراز السويسري مع طباعة بسيطة راقية، ولون ورق دافئ، ورسم بياني دائري مجوّف للمشاركين، وتفاعلات تحريرية خفيفة.',
  },
  'design-taste-frontend': {
    description:
      'مهارة واجهة أمامية مضادة للركاكة لصفحات الهبوط، والمعارض، وإعادة التصميم. يقرأ الوكيل الموجز، ويستنتج اتجاه التصميم الصحيح، ويسلّم واجهات لا تبدو قالبية. أنظمة تصميم حقيقية عند الاقتضاء، والتدقيق أولًا في إعادة التصميم، وفحص صارم قبل الإطلاق.',
    examplePrompt:
      'أنشئ صفحة هبوط راقية تتبع design-taste-frontend: استنتج قراءة التصميم، واضبط الإعدادات، وتجنب أنماط ركاكة الذكاء الاصطناعي، وأخرج عنصر HTML متجاوبًا ومصقولًا.',
  },
  'design-taste-frontend-v1': {
    description:
      'مهارة الذوق الأصلية v1، محفوظة للمشاريع التي تعتمد على سلوكها الدقيق. الإعداد الافتراضي الحالي هو `design-taste-frontend` (v2 التجريبي)، وهو إعادة كتابة جوهرية. استخدم اسم التثبيت v1 هذا فقط إذا كنت بحاجة إلى توافق رجعي دقيق.',
    examplePrompt:
      'أنشئ صفحة تسويقية مصقولة باستخدام design-taste-frontend-v1 مع طباعة قوية، وتباعد، وحركة، وضوابط مضادة للركاكة.',
  },
  'theme-factory': {
    description:
      'طبّق سمات احترافية للخطوط والألوان على العناصر بما في ذلك الشرائح، والمستندات، والتقارير، وصفحات هبوط HTML. تأتي مع 10 سمات معدّة مسبقًا.',
    examplePrompt:
      'طبّق سمات احترافية للخطوط والألوان على العناصر بما في ذلك الشرائح، والمستندات، والتقارير، وصفحات هبوط HTML.',
  },
  'threejs': {
    description:
      'مهارات Three.js لإنشاء عناصر ثلاثية الأبعاد وتجارب تفاعلية في المتصفح — المشاهد، والخامات، وعناصر التحكم، والمعالجة اللاحقة.',
    examplePrompt:
      'مهارات Three.js لإنشاء عناصر ثلاثية الأبعاد وتجارب تفاعلية في المتصفح — المشاهد، والخامات، وعناصر التحكم، والمعالجة اللاحقة.',
  },
  'ui-skills': {
    description:
      'قيود ذات رأي واضح ومتطورة لتوجيه الوكلاء عند بناء الواجهات. مفيدة للحفاظ على تماسك المخرجات عبر العديد من العناصر الصغيرة في واجهة المستخدم.',
    examplePrompt:
      'قيود ذات رأي واضح ومتطورة لتوجيه الوكلاء عند بناء الواجهات.',
  },
  'ui-ux-pro-max': {
    description:
      'مدخل UI/UX Pro Max للكتالوج فقط. القوالب الأصلية الكاملة والبيانات وسير عمل البحث غير مضمّنة في Open Design.',
    examplePrompt:
      'مدخل UI/UX Pro Max للكتالوج فقط.',
  },
  'venice-audio-music': {
    description:
      'نقاط نهاية لإدراج توليد الموسيقى في قائمة الانتظار واسترجاعها وإكمالها عبر Venice.ai. مناسبة للنغمات الإعلانية والحلقات الخلفية والتلحين التجريبي.',
    examplePrompt:
      'نقاط نهاية لإدراج توليد الموسيقى في قائمة الانتظار واسترجاعها وإكمالها عبر Venice.ai.',
  },
  'venice-audio-speech': {
    description:
      'نماذج تحويل النص إلى كلام والأصوات والتنسيقات والبث عبر Venice.ai. مفيدة للسرد والتعليق الصوتي وأصوات الوكلاء التحادثية.',
    examplePrompt:
      'نماذج تحويل النص إلى كلام والأصوات والتنسيقات والبث عبر Venice.ai.',
  },
  'venice-image-edit': {
    description:
      'تعديلات الصور وتحسين دقتها وإزالة الخلفية عبر واجهة Venice.ai API.',
    examplePrompt:
      'تعديلات الصور وتحسين دقتها وإزالة الخلفية عبر واجهة Venice.ai API.',
  },
  'venice-image-generate': {
    description:
      'نقاط نهاية توليد الصور والأنماط المتاحة عبر واجهة Venice.ai API.',
    examplePrompt:
      'نقاط نهاية توليد الصور والأنماط المتاحة عبر واجهة Venice.ai API.',
  },
  'venice-video': {
    description:
      'سير عمل توليد الفيديو والنسخ النصي عبر واجهة Venice.ai API.',
    examplePrompt:
      'سير عمل توليد الفيديو والنسخ النصي عبر واجهة Venice.ai API.',
  },
  'vfx-text-cursor': {
    description:
      'أثر ضوئي للمؤشر وأشعة لونية ووهج اتجاهي لكشف الاقتباسات كلمةً كلمة في مقدمات الفيديو.',
    examplePrompt:
      'استخدم قالب VFX Text Cursor لتحويل محتواي إلى كشف اقتباس بمقدمة فيديو مع آثار ضوئية للمؤشر وأشعة لونية ووهج اتجاهي. حافظ على البصمة البصرية للقالب، واستخدم محتوى وبيانات حقيقية، وتجنّب نص lorem ipsum أو الصور النائبة.',
  },
  'video-downloader': {
    description:
      'تنزيل مقاطع الفيديو من YouTube والمنصات الأخرى للمشاهدة دون اتصال أو التعديل أو الأرشفة مع دعم تنسيقات وخيارات جودة متنوعة.',
    examplePrompt:
      'تنزيل مقاطع الفيديو من YouTube والمنصات الأخرى للمشاهدة دون اتصال أو التعديل أو الأرشفة مع دعم تنسيقات وخيارات جودة متنوعة.',
  },
  'video-hyperframes': {
    description:
      'رسوم متحركة لإطارات متصلة متوافقة مع HyperFrames / Remotion مع دعم التشغيل التلقائي.',
    examplePrompt:
      'استخدم قالب Hyperframes Video لتحويل محتواي إلى رسوم متحركة لإطارات متصلة متوافقة مع HyperFrames / Remotion مع دعم التشغيل التلقائي. حافظ على البصمة البصرية للقالب، واستخدم محتوى وبيانات حقيقية، وتجنّب نص lorem ipsum أو الصور النائبة.',
  },
  'web-artifacts-builder': {
    description:
      'بناء عناصر HTML معقدة لـ claude.ai باستخدام React وTailwind. سير العمل المرجعي من Anthropic لإطلاق عناصر غنية وقابلة للتضمين.',
    examplePrompt:
      'بناء عناصر HTML معقدة لـ claude.ai باستخدام React وTailwind.',
  },
  'web-design-guidelines': {
    description:
      'إرشادات ومعايير تصميم الويب من فريق هندسة Vercel. تغطي التخطيط والطباعة والألوان والحركة وإمكانية الوصول لواجهة المنتج.',
    examplePrompt:
      'إرشادات ومعايير تصميم الويب من فريق هندسة Vercel.',
  },
  'weread-year-in-review-video-template': {
    description:
      'قالب فيديو HyperFrames مستوحى من WeRead لتقارير القراءة السنوية العمودية،\nولوحات القراءة الشخصية، وملخصات ملاحظات الكتب، وقصص مراجعة العام القابلة للمشاركة. استخدمه عندما يرغب المستخدمون في تقرير قراءة بنسبة 9:16 من HTML إلى MP4 بملمس ورقي دافئ،\nوطباعة صينية تحريرية، واستعارات صفحات الكتب، وإبرازات للبيانات،\nوحركة حتمية.',
    examplePrompt:
      'أنشئ فيديو تقرير قراءة سنوي بنمط WeRead بنسبة 9:16 من HyperFrames يتضمن 12 مشهدًا، وملمسًا ورقيًا دافئًا، وانتقالات صفحات الكتب، وإحصاءات القراءة، والملاحظات، والكلمات المفتاحية، وبطاقة شخصية قارئ في النهاية.',
  },
  'wpds': {
    description:
      'نظام تصميم WordPress. طبّق رموز التصميم الرسمية والطباعة وأنماط المكوّنات الخاصة بـ WordPress على القوالب والمواقع.',
    examplePrompt:
      'نظام تصميم WordPress.',
  },
  'youtube-clipper': {
    description:
      'توليد مقاطع YouTube وتحريرها بسير عمل آلي — جلب الفيديو المصدر، وتقطيع اللحظات البارزة، وإضافة التسميات التوضيحية، والتصدير.',
    examplePrompt:
      'توليد مقاطع YouTube وتحريرها بسير عمل آلي — جلب الفيديو المصدر، وتقطيع اللحظات البارزة، وإضافة التسميات التوضيحية، والتصدير.',
  },
};

export const AR_DESIGN_SYSTEM_SUMMARIES: Record<string, string> = {
  'agentic': 'واجهة تعتمد الذكاء الاصطناعي التحادثي أولًا بأقل قدر من عناصر التحكم، ونتائج واضحة، وتدفقات مهام مفوَّضة لسير العمل الوكيلي.',
  'airbnb': 'سوق سفر. لمسة مرجانية دافئة، يعتمد على التصوير الفوتوغرافي، وواجهة مستخدم بحواف مستديرة.',
  'airtable': 'هجين بين جدول البيانات وقاعدة البيانات. جمالية بيانات منظّمة وملوّنة وودودة.',
  'ant': 'نظام تصميم منظّم موجّه للمؤسسات يركّز على الوضوح والاتساق والكفاءة لتطبيقات الويب الكثيفة بالبيانات.',
  'apple': 'إلكترونيات استهلاكية. مساحة بيضاء فاخرة، وخط SF Pro، وصور سينمائية.',
  'application': 'لوحة تحكم تطبيق بجمالية ذات طابع بنفسجي، وتنقّل في الشريط العلوي، وتخطيطات قائمة على البطاقات، وسير عمل يضع المطوّرين أولًا.',
  'arc': '"المتصفح الذي يتصفّح نيابةً عنك." أسطح شبه شفافة، ودفء متدرّج، وتخطيط يبدأ بالشريط الجانبي.',
  'artistic': 'نمط معبّر عالي التباين مع طباعة إبداعية واختيارات لونية جريئة لواجهات لافتة بصريًا.',
  'atelier-zero': 'نظام بصري بمستوى المجلات معتمد على الكولاج: لوحة ورقية دافئة، وصور سريالية\nمن الجص والعمارة، وخط عرض ضخم، وخطوط رفيعة جدًا،\nوعلامات أقسام بأرقام رومانية، وتعليقات تحريرية صغيرة.\nمستوحى من نسخة الإنتاج v',
  'bento': 'تخطيط شبكي معياري بكتل تشبه البطاقات، وتسلسل هرمي واضح، وتباعد ناعم، وتباين بصري خفيف لواجهات منظّمة وسهلة المسح.',
  'binance': 'منصة تداول عملات رقمية. لمسة صفراء جريئة على خلفية أحادية اللون، بإلحاح صالات التداول.',
  'bmw': 'سيارات فاخرة. أسطح داكنة راقية، وجمالية هندسية ألمانية دقيقة.',
  'bmw-m': 'علامة فرعية لأداء رياضة السيارات. أسطح قمرة قيادة شبه سوداء، ولمسات BMW M ثلاثية الألوان، وهندسة حادة الزوايا.',
  'bold': 'حضور بصري قوي مع طباعة ثقيلة الوزن، وألوان عالية التباين، وتخطيطات مهيمنة.',
  'brutalism': 'جمالية خام مناهضة للتصميم مستوحاة من العمارة الخرسانية بعناصر غير مزخرفة، وتخطيطات صادمة، وبساطة وظيفية.',
  'bugatti': 'علامة سيارات خارقة. لوحة سوداء سينمائية، وتقشف أحادي اللون، وخط عرض ضخم.',
  'cafe': 'واجهة دافئة مستوحاة من المقاهي بألوان دافئة، وطباعة ناعمة، وتخطيطات نظيفة لتجربة تصفح مريحة.',
  'cal': 'جدولة مفتوحة المصدر. واجهة محايدة نظيفة، وبساطة موجّهة للمطورين.',
  'canva': 'منصة إبداع بصري. تدرّج أرجواني-أزرق زاهٍ، ومسافات سخية، وهندسة ودودة.',
  'cisco': 'علامة بنية تحتية للمؤسسات. أسطح داكنة موثوقة، ولون Cisco Blue المميز، ووضوح تقني.',
  'claude': 'مساعد الذكاء الاصطناعي من Anthropic. لمسة تيراكوتا دافئة، وتخطيط تحريري نظيف.',
  'clay': 'وكالة إبداعية. أشكال عضوية، وتدرّجات ناعمة، وتخطيط بإخراج فني.',
  'claymorphism': 'أشكال ناعمة مستديرة شبه ثلاثية الأبعاد تحاكي الصلصال القابل للتشكيل بعناصر مرحة منتفخة وأسطح ملوّنة.',
  'clean': 'تصميم يركّز على البساطة مع مساحات بيضاء وافرة، وطباعة سهلة القراءة، ولوحة ألوان محدودة لتقليل الفوضى البصرية.',
  'clickhouse': 'قاعدة بيانات تحليلية سريعة. بأسلوب توثيق تقني بلمسات صفراء.',
  'cohere': 'منصة ذكاء اصطناعي للمؤسسات. تدرّجات نابضة بالحياة، وجمالية لوحة معلومات غنية بالبيانات.',
  'coinbase': 'منصة تداول عملات رقمية. هوية زرقاء نظيفة، تركّز على الثقة، بإحساس مؤسسي.',
  'colorful': 'لوحات ألوان وتدرّجات نابضة بالحياة وعالية التباين لتجارب مستخدم جذّابة ولا تُنسى وعصرية.',
  'composio': 'منصة تكامل الأدوات. تصميم داكن عصري مع أيقونات تكامل ملوّنة.',
  'contemporary': 'تصميم بسيط معاصر مع شبكات بنتو، ودعم الوضع الداكن، وتخطيطات عالية الأداء وسهلة الوصول.',
  'corporate': 'تصميم احترافي متوافق مع العلامة التجارية مع شبكات منظّمة، وتخطيطات بسيطة، وأنماط مؤسسية متّسقة.',
  'cosmic': 'جمالية خيال علمي مستقبلية مع سمات داكنة، ولمسات نيون نابضة بالحياة، وعناصر مكانية غامرة.',
  'creative': 'تصميم مرح يقوده الطابع الشخصي مع طباعة معبّرة ورسومات جريئة لصفحات الهبوط والمشاريع الإبداعية.',
  'cursor': 'محرّر أكواد يضع الذكاء الاصطناعي أولاً. واجهة داكنة أنيقة، ولمسات بتدرّجات لونية.',
  'dashboard': 'جمالية منصة سحابية بسمة داكنة مع شبكات معيارية، ولوحات شبيهة بالزجاج، وتسلسل بيانات قوي للوحات الإنتاجية.',
  'default': 'إعداد افتراضي نظيف موجّه للمنتجات لأدوات B2B، ولوحات المعلومات، وصفحات الأدوات المساعدة.',
  'discord': 'منصة صوت / دردشة. لون بنفسجي-أزرق غامق، وأسطح داكنة بالأساس، ولحظات لمسات مرحة.',
  'dithered': 'تقنية تصيير بنمط النقاط تحاكي درجات الظل بلوحة ألوان محدودة لمؤثرات بصرية حنينية ورجعية عالية التباين.',
  'doodle': 'أسلوب رسم يدوي شبيه بالاسكتش مع خربشات، وخطوط بخط اليد، وخطوط غير مكتملة لإحساس مرح وغير رسمي.',
  'dramatic': 'تصميم مسرحي عالي التباين مع تخطيطات جريئة، ومرئيات غامرة، وتركيبات غير تقليدية تستحوذ على الانتباه.',
  'duolingo': 'منصة تعلّم اللغات. أخضر بومة مشرق، وظلال سميكة، ومتعة بأسلوب الألعاب.',
  'editorial': 'تخطيط تحريري مستوحى من المجلات مع طباعة سيريف مصقولة، وشبكات منظّمة، وتجارب قراءة أنيقة.',
  'elegant': 'جمالية رشيقة مصقولة مع طباعة رقيقة، ولوحات ألوان بسيطة، وتخطيطات مصقولة تفيض رُقيًّا.',
  'elevenlabs': 'منصة صوت بالذكاء الاصطناعي. واجهة سينمائية داكنة، وجماليات موجات صوتية.',
  'energetic': 'أسلوب ديناميكي نابض بالحياة مع حدود سميكة، وأشكال هندسية، وألوان عالية التباين، وطباعة معبّرة تنقل الحركة والحيوية.',
  'enterprise': 'تصميم مؤسسي نظيف عالي التباين لسير العمل القائم على البيانات مع أنماط سحب وإفلات بديهية وتخطيطات منظّمة.',
  'expo': 'منصة React Native. سمة داكنة، وتباعد أحرف ضيّق، وتركيز على الأكواد.',
  'expressive': 'تصميم نابض بالحياة يقوده الطابع الشخصي مع ألوان جريئة، ورسومات مرحة، وتخطيطات ديناميكية توازن بين الإبداع والبنية.',
  'fantasy': 'جمالية فانتازيا مستوحاة من الألعاب مع مرئيات جريئة وراقية، ولوحات ألوان غنية، وعناصر موضوعية غامرة.',
  'ferrari': 'سيارات فاخرة. أسلوب تحريري بتباين الضوء والظل، ولمسات Ferrari Red، وأسود سينمائي.',
  'figma': 'أداة تصميم تعاونية. ألوان متعددة نابضة بالحياة، مرحة لكن احترافية.',
  'flat': 'نمط بسيط ثنائي الأبعاد بألوان نابضة بالحياة وخطوط أنيقة وبلا تأثيرات ثلاثية الأبعاد، لواجهات سريعة وسهلة الاستخدام.',
  'framer': 'منشئ مواقع. أسود وأزرق جريء، يعتمد الحركة أولاً، يقود التصميم.',
  'friendly': 'تصميم سهل المنال وبديهي بعناصر دائرية ومساحات بيضاء وفيرة ولوحات ألوان باستيل ناعمة.',
  'futuristic': 'تصميم استشرافي بخطوط مستوحاة من التقنية وتخطيطات عصرية وجماليات أنيقة تقودها روح الابتكار.',
  'github': 'منصة تركّز على الكود. كثافة وظيفية، دقة أزرق على أبيض، أسس Primer.',
  'glassmorphism': 'تأثير الزجاج المصنفر بطبقات شبه شفافة وضبابية خفيفة وحدود مضيئة، لإضفاء العمق والأناقة العصرية.',
  'gradient': 'انتقالات لونية سلسة وأسطح غنية بالتدرجات، لواجهات عصرية مرحة بعمق بصري.',
  'hashicorp': 'أتمتة البنية التحتية. نظافة مؤسسية، أبيض وأسود.',
  'hud': 'شاشة عرض علوية لطائرة مقاتلة / مروحية. أخضر فسفوري على خلفية شبه سوداء، طبقات بيانات بأحرف كبيرة، هندسة زاويّة. لا غموض على السرعة والارتفاع.',
  'huggingface': 'مركز مجتمع تعلّم الآلة. لمسة صفراء مشمسة، هوية بخط أحادي المسافة، مبهج وكثيف.',
  'ibm': 'تقنية مؤسسية. نظام تصميم Carbon، لوحة زرقاء منظّمة.',
  'intercom': 'مراسلة العملاء. لوحة زرقاء ودودة، أنماط واجهة محادثة.',
  'kami': 'نظام ورقي تحريري: خلفية رق دافئة، لمسة أزرق حبري، تسلسل هرمي يقوده الخط المذيّل. مصمم للسير الذاتية والصفحات المنفردة والأوراق البيضاء والمحافظ وعروض الشرائح — أي شيء يجب أن يبدو كطباعة عالية الجودة لا كواجهة. متعدد اللغات افتراضيًا',
  'kraken': 'تداول العملات المشفّرة. واجهة داكنة بلمسة بنفسجية، لوحات معلومات كثيفة البيانات.',
  'lamborghini': 'علامة سيارات خارقة. أسطح سوداء خالصة، لمسات ذهبية، خطوط درامية بأحرف كبيرة.',
  'levels': 'تصميم يركّز على التحويل، يزيل الاحتكاك ويوجّه المستخدمين نحو الفعل عبر الوضوح والثقة والسرعة.',
  'linear-app': 'إدارة المشاريع. بساطة فائقة، دقة، لمسة بنفسجية.',
  'lingo': 'تصميم مرح وبسيط بألوان زاهية وأشكال دائرية وحدود ثلاثية الأبعاد ملموسة ورسوم توضيحية ودودة، لواجهات سهلة المنال.',
  'loom': 'فيديو غير متزامن من Loom. بنفسجي أساسي، أسطح ودودة، تخطيط يركّز على الفيديو. أنيق واحترافي دون أن يكون رسميًا.',
  'lovable': 'منشئ متكامل بالذكاء الاصطناعي. تدرجات مرحة، جماليات تطوير ودودة.',
  'luxury': 'جماليات داكنة راقية بعناوين جريئة ولوحة أحادية اللون وإحساس فاخر، لتجارب العلامات الفاخرة.',
  'mastercard': 'شبكة مدفوعات عالمية. خلفية كريمية دافئة، أشكال كبسولات مدارية، دفء تحريري.',
  'material': 'تصميم Material من Google بأسطح متعددة الطبقات وتنسيق ديناميكي وحركة مدمجة وأنماط متجاوبة عبر المنصات.',
  'meta': 'متجر تجزئة تقني. يركّز على التصوير، أسطح ثنائية فاتحة/داكنة، أزرار حث Meta Blue.',
  'minimal': 'تصميم مجرّد يبرز المساحات البيضاء والخطوط الأنيقة واللون المتحفظ لأقصى وضوح وتركيز.',
  'minimax': 'مزوّد نماذج ذكاء اصطناعي. واجهة داكنة جريئة بلمسات نيون.',
  'mintlify': 'منصة توثيق. أنيقة، بلمسة خضراء، محسّنة للقراءة.',
  'miro': 'تعاون بصري. لمسة صفراء زاهية، جماليات لوحة لا نهائية.',
  'mission-control': 'مراقبة المهام الفضائية / الجوية. مركز قيادة داكن، قياسات عن بُعد كهرمانية، دقة بخط أحادي المسافة. الوضوح الوظيفي فوق كل شيء.',
  'mistral-ai': 'مزوّد نماذج لغوية مفتوحة الأوزان. بساطة بهندسة فرنسية، بدرجات بنفسجية.',
  'modern': 'نمط تحريري معاصر بخطوط مذيّلة ولوحات بسيطة وتخطيطات أنيقة، لمنتجات رقمية مصقولة.',
  'mongodb': 'قاعدة بيانات مستندية. هوية بعلامة ورقة خضراء، تركيز على توثيق المطورين.',
  'mono': 'تصميم يقوده الخط الأحادي المسافة مستوحى من الماتريكس، بعناصر عالية التباين وكثافة مدمجة وجماليات أناقة الهاكر.',
  'neobrutalism': 'رؤية معاصرة للوحشية بحدود جريئة وألوان لمسات زاهية وتخطيطات خام عالية التباين على أسطح دافئة.',
  'neon': 'تأثيرات توهج نيون كهربائية بأزواج ألوان عالية التباين، لواجهات جريئة تخطف الانتباه.',
  'neumorphism': 'عناصر واجهة ناعمة بارزة بظلال داخلية وخارجية على أسطح أحادية اللون، لمظهر ملموس وغائر.',
  'nike': 'تجزئة رياضية. واجهة أحادية اللون، خط ضخم بأحرف كبيرة، تصوير يملأ الكادر بالكامل.',
  'notion': 'مساحة عمل متكاملة. بساطة دافئة، عناوين بخط مذيّل، أسطح ناعمة.',
  'nvidia': 'حوسبة GPU. طاقة خضراء وسوداء، جماليات قوة تقنية.',
  'ollama': 'شغّل نماذج LLM محليًا. تصميم يعتمد على الطرفية أولًا، ببساطة أحادية اللون.',
  'openai': 'نظام هادئ شبه أحادي اللون يرتكز على لون أسود مائل إلى الأزرق المخضرّ العميق، مع مساحات بيضاء وفيرة وطباعة تحريرية.',
  'opencode-ai': 'منصة برمجة بالذكاء الاصطناعي. ثيم داكن موجّه للمطوّرين.',
  'pacman': 'تصميم مستوحى من ألعاب الأركيد الكلاسيكية بخطوط بكسلية، وحدود منقّطة، وألوان مرحة عالية التباين، وجماليات ألعاب 8-بت.',
  'paper': 'تصميم بملمس ورقي مستوحى من الطباعة بألوان قليلة، وطباعة نظيفة بخطوط مذيّلة/غير مذيّلة، وخصائص سطحية ملموسة.',
  'perplexity': 'محرك بحث حواري بالذكاء الاصطناعي. خلفية داكنة عميقة، طباعة حادة، لمسة بنفسجية واحدة، وتسلسل معلومات كثيف.',
  'perspective': 'تصميم بعمق مكاني يستخدم المناظر الإيزومترية، ونقاط التلاشي، وعناصر متعددة الطبقات توجّه الانتباه عبر واقعية شبيهة بالأبعاد الثلاثية.',
  'pinterest': 'اكتشاف بصري. لمسة حمراء، شبكة بنائية، الصورة أولًا.',
  'playstation': 'بيع أجهزة ألعاب بالتجزئة. تخطيط قنوات ثلاثي الأسطح، خط عرض هادئ وموثوق، تكبير سماوي عند التمرير.',
  'posthog': 'تحليلات المنتجات. هوية مرحة بشعار القنفذ، واجهة داكنة صديقة للمطوّرين.',
  'premium': 'جمالية فاخرة مستوحاة من Apple بمسافات دقيقة، وطباعة عصرية، ولغة بصرية مصقولة ومتقنة.',
  'professional': 'تصميم مصقول جاهز للأعمال بطباعة عصرية، وتخطيطات منظّمة، وهوية بصرية تبعث على الثقة.',
  'publication': 'لغة بصرية مستوحاة من الطباعة للكتب والمجلات والتقارير، بشبكات تحريرية وطباعة معبّرة.',
  'raycast': 'مشغّل إنتاجية. واجهة داكنة أنيقة بلمسات تدرّج زاهية.',
  'refined': 'أسلوب عصري بسيط منتقى بعناية، بطباعة مذيّلة أنيقة، ولوحات ألوان راقية ومتحفّظة.',
  'renault': 'سيارات فرنسية. تدرّجات شفقية زاهية، طباعة NouvelR، وطاقة جريئة.',
  'replicate': 'شغّل نماذج التعلّم الآلي عبر API. خلفية بيضاء نظيفة، موجّهة للكود.',
  'resend': 'API للبريد الإلكتروني. ثيم داكن بسيط، بلمسات أحادية المسافة.',
  'retro': 'تصميم استرجاعي بطباعة مستوحاة من الطراز القديم، ولوحات ألوان رترو عالية التباين، وعناصر بصرية حنينية.',
  'revolut': 'خدمات مصرفية رقمية. واجهة داكنة أنيقة، بطاقات متدرّجة، ودقّة التقنية المالية.',
  'runwayml': 'توليد فيديو بالذكاء الاصطناعي. واجهة داكنة سينمائية، وتخطيط غني بالوسائط.',
  'sanity': 'نظام إدارة محتوى Headless. لمسة حمراء، وتخطيط تحريري يضع المحتوى أولًا.',
  'sentry': 'مراقبة الأخطاء. لوحة بيانات داكنة كثيفة المعلومات، بلمسة وردية بنفسجية.',
  'shadcn': 'تصميم مستوحى من Shadcn/ui بمكوّنات بسيطة ونظيفة، ولوحة أحادية اللون، وأنماط تعتمد المرافق أولًا.',
  'shopify': 'منصة تجارة إلكترونية. تصميم سينمائي داكن أولًا، بلمسة خضراء نيون وخط فائق الخفّة.',
  'simple': 'تصميم مباشر بلا زخارف، بطباعة نظيفة، وألوان محايدة، وتخطيطات بديهية لا تعترض الطريق.',
  'skeumorphism': 'محاكاة للعالم الواقعي بأسطح ذات ملمس، وتأثيرات ثلاثية الأبعاد، واستعارات مادية مألوفة لواجهات رقمية بديهية.',
  'slack': 'منصة تواصل في مكان العمل. لون باذنجاني أساسي، ولوحة شعار متعددة اللمسات، وأسطح فاتحة مع شريط جانبي داكن، دافئة وودودة.',
  'sleek': 'جمالية عصرية بسيطة بخطوط نظيفة، ولوحة ألوان مقصودة، وتفاعلات خفيّة، ومسافات متّسقة.',
  'spacex': 'تكنولوجيا الفضاء. تباين صارخ بالأبيض والأسود، صور تملأ الكادر، وطابع مستقبلي.',
  'spacious': 'مساحات بيضاء وفيرة، وحشوة متّسقة، وتخطيطات قائمة على الشبكة لواجهات نظيفة وسهلة القراءة وتتنفّس.',
  'spotify': 'بث الموسيقى. أخضر زاهٍ على خلفية داكنة، خط جريء، يقوده فن غلاف الألبوم.',
  'starbucks': 'علامة قهوة عالمية للبيع بالتجزئة. نظام أخضر رباعي المستويات، خلفية كريمية دافئة، وأزرار كاملة الاستدارة.',
  'storytelling': 'تصميم سردي يستخدم العناصر البصرية والنصوص والتفاعل لإرشاد المستخدمين عبر رحلات جذّابة وذات صدى عاطفي.',
  'stripe': 'بنية تحتية للمدفوعات. تدرّجات بنفسجية مميّزة، وأناقة بوزن خط 300.',
  'supabase': 'بديل Firebase مفتوح المصدر. ثيم أخضر زمرّدي داكن، يضع الكود أولًا.',
  'superhuman': 'عميل بريد إلكتروني سريع. واجهة داكنة فاخرة، تعتمد لوحة المفاتيح أولًا، بتوهّج بنفسجي.',
  'tesla': 'سيارات كهربائية. تجريد جذري، تصوير يملأ كامل نافذة العرض، وواجهة شبه معدومة.',
  'tetris': 'تصميم مستوحى من لعبة المكعّبات الكلاسيكية بألوان مرحة، وخطوط عرض جريئة، وتخطيطات مدمجة عالية الطاقة.',
  'theverge': 'وسائط تحريرية تقنية. لمسات نعناع حمضي وفوق بنفسجي، خط عرض Manuka، وبطاقات قصص بطابع منشورات الحفلات الصاخبة.',
  'together-ai': 'بنية تحتية مفتوحة المصدر للذكاء الاصطناعي. تصميم تقني بأسلوب المخططات الهندسية.',
  'totality-festival': 'نظام داكن فاخر بطابع كوني وتأثير زجاجي يجسّد الرهبة العميقة لكسوف الشمس — أسطح من حجر السبج، وإبرازات كهرمانية بلون "الإكليل"، ولمسات سماوية زرقاء أثيرية.',
  'trading-terminal': 'طرفية تداول مالي بأسلوب Bloomberg. داكنة فقط، كثيفة البيانات، بإشارات شراء/بيع باللونين السماوي والمرجاني. كل شيء قابل للقراءة بلمحة من مسافة مترين.',
  'uber': 'منصة تنقّل. أبيض وأسود جريء، خط محكم، وطاقة حضرية.',
  'urdu': 'تجارب رقمية بالأردية أولاً مع دعم أصيل للكتابة من اليمين إلى اليسار، وطباعة بخط النستعليق، وانسجام ثنائي اللغة.',
  'vercel': 'نشر الواجهات الأمامية. دقّة بالأبيض والأسود، خط Geist.',
  'vibrant': 'تصميم حيوي وملوّن بطباعة جريئة ومرحة، ولمسات دافئة، وطاقة بصرية ديناميكية.',
  'vintage': 'حنين إلى حقبة الخمسينيات حتى التسعينيات بلمسات محاكية للواقع، وملمس حُبيبي، ولوحات ألوان كلاسيكية، وطباعة بأسلوب البكسل.',
  'vodafone': 'علامة اتصالات عالمية. عرض ضخم بأحرف كبيرة، وأشرطة فصول بلون Vodafone الأحمر.',
  'voltagent': 'إطار عمل لوكلاء الذكاء الاصطناعي. لوحة سوداء حالكة، ولمسة زمردية، وطابع طرفي أصيل.',
  'warm-editorial': 'جمالية مجلة يقودها الخط المذيّل (serif). لمسة طينية على ورق دافئ مائل إلى الأبيض —\nمناسبة للمحتوى الطويل والتحريري وصفحات التسويق التي تقودها العلامة التجارية.',
  'warp': 'طرفية حديثة. واجهة داكنة شبيهة ببيئة IDE، وواجهة أوامر قائمة على الكتل.',
  'webex': 'منصة تعاون. طباعة بإحساس الزخم، ونظام إجراءات أزرق، وطيف لمسات متعدد المستخدمين.',
  'webflow': 'منشئ ويب مرئي. بلمسة زرقاء، وجمالية موقع تسويقي مصقول.',
  'wechat': 'لغة بصرية للعلامة التجارية لبرامج WeChat المصغّرة، والحسابات الرسمية، وامتدادات النظام البيئي المفتوح.',
  'wired': 'مجلة تقنية. كثافة صحيفة كبيرة بلون الورق الأبيض، وعرض مذيّل مخصص، وعناوين فرعية بخط أحادي المسافة، وروابط بلون الحبر الأزرق.',
  'wise': 'تحويل الأموال. لمسة خضراء زاهية، ودود وواضح.',
  'x-ai': 'مختبر الذكاء الاصطناعي لإيلون ماسك. أحادي اللون صارم، وبساطة مستقبلية.',
  'xiaohongshu': 'منصة اجتماعية للمحتوى الذي ينشئه المستخدمون حول نمط الحياة. لون أحمر واحد للعلامة، وزوايا منحنية سخية، والمحتوى أولاً.',
  'zapier': 'منصة أتمتة. برتقالي دافئ، وودود يقوده الرسم التوضيحي.',
};

export const AR_DESIGN_SYSTEM_CATEGORIES: Record<string, string> = {
  'AI & LLM': 'الذكاء الاصطناعي ونماذج اللغة الكبيرة',
  'Automotive': 'السيارات',
  'Backend & Data': 'الواجهة الخلفية والبيانات',
  'Bold & Expressive': 'جريء ومعبّر',
  'Creative & Artistic': 'إبداعي وفني',
  'Design & Creative': 'التصميم والإبداع',
  'Developer Tools': 'أدوات المطوّرين',
  'E-Commerce & Retail': 'التجارة الإلكترونية والتجزئة',
  'Editorial & Print': 'التحرير والطباعة',
  'Editorial / Personal / Publication': 'تحريري / شخصي / نشر',
  'Editorial · Studio': 'تحريري · استوديو',
  'Fintech & Crypto': 'التقنية المالية والعملات المشفّرة',
  'Layout & Structure': 'التخطيط والبنية',
  'Media & Consumer': 'الإعلام والمستهلك',
  'Modern & Minimal': 'عصري وبسيط',
  'Morphism & Effects': 'التأثيرات والتحوّلات الشكلية',
  'Productivity & SaaS': 'الإنتاجية وبرمجيات SaaS',
  'Professional & Corporate': 'احترافي ومؤسسي',
  'Retro & Nostalgic': 'كلاسيكي وحنيني',
  'Social & Messaging': 'التواصل الاجتماعي والمراسلة',
  'Starter': 'المبتدئ',
  'Themed & Unique': 'مُصمّم وفريد',
};

export const AR_PROMPT_TEMPLATE_CATEGORIES: Record<string, string> = {
  'Advertising': 'الإعلانات',
  'Anime': 'أنمي',
  'Anime / Manga': 'أنمي / مانغا',
  'App / Web Design': 'تصميم التطبيقات / الويب',
  'Branding': 'الهوية التجارية',
  'Cinematic': 'سينمائي',
  'Data': 'البيانات',
  'Game UI': 'واجهة الألعاب',
  'General': 'عام',
  'Illustration': 'الرسم التوضيحي',
  'Infographic': 'إنفوغرافيك',
  'Live Artifact': 'عمل حي',
  'Marketing': 'التسويق',
  'Motion Graphics': 'رسوميات متحركة',
  'Product': 'المنتج',
  'Profile / Avatar': 'الملف الشخصي / الصورة الرمزية',
  'Short Form': 'مقاطع قصيرة',
  'Social / Meme': 'اجتماعي / ميم',
  'Social Media Post': 'منشور على وسائل التواصل الاجتماعي',
  'Travel': 'السفر',
  'VFX / Fantasy': 'مؤثرات بصرية / فانتازيا',
  'VFX / HTML-in-Canvas': 'مؤثرات بصرية / HTML داخل اللوحة',
};

export const AR_PROMPT_TEMPLATE_TAGS: Record<string, string> = {
  '3d': 'ثلاثي الأبعاد',
  '3d-render': 'عرض ثلاثي الأبعاد',
  'action': 'أكشن',
  'ancient-china': 'الصين القديمة',
  'anime': 'أنمي',
  'app-showcase': 'عرض التطبيق',
  'archery': 'الرماية بالقوس',
  'arpg': 'arpg',
  'audio-reactive': 'تفاعلي مع الصوت',
  'boss-fight': 'معركة الزعيم',
  'brand': 'العلامة التجارية',
  'branding': 'الهوية التجارية',
  'captions': 'التسميات التوضيحية',
  'cavalry': 'سلاح الفرسان',
  'chart': 'مخطط بياني',
  'childlike': 'طفولي',
  'choreography': 'تصميم الحركة',
  'cinematic': 'سينمائي',
  'cinematic-romance': 'رومانسية سينمائية',
  'combat': 'قتال',
  'combo': 'كومبو',
  'companion-to-image': 'مرافق إلى صورة',
  'counter': 'عدّاد',
  'crayon': 'أقلام شمعية',
  'cyberpunk': 'سايبربانك',
  'dance': 'رقص',
  'dashboard': 'لوحة معلومات',
  'data': 'بيانات',
  'data-viz': 'تصور البيانات',
  'destruction': 'تدمير',
  'displacement': 'إزاحة',
  'editorial': 'تحريري',
  'elden-ring': 'elden-ring',
  'endcard': 'بطاقة ختامية',
  'escort': 'مرافقة',
  'escort-mission': 'مهمة مرافقة',
  'fantasy': 'خيال',
  'fashion': 'أزياء',
  'fighting-game': 'لعبة قتال',
  'food': 'طعام',
  'game-cinematic': 'مشهد سينمائي للعبة',
  'game-ui': 'واجهة لعبة',
  'grid-sheet': 'ورقة شبكية',
  'guanyu': 'guanyu',
  'hand-drawn': 'مرسوم باليد',
  'hero': 'بطل',
  'html-in-canvas': 'HTML داخل اللوحة',
  'hud': 'HUD',
  'hud-safe': 'HUD آمن',
  'hype': 'حماس',
  'hyperframes': 'HyperFrames',
  'idol': 'أيقونة',
  'illustration': 'رسم توضيحي',
  'image-to-image': 'صورة إلى صورة',
  'infographic': 'إنفوجرافيك',
  'iphone': 'iPhone',
  'japanese': 'ياباني',
  'karaoke': 'كاريوكي',
  'key-visual': 'الصورة الرئيسية',
  'keynote': 'عرض تقديمي',
  'kinetic-typography': 'الخط الحركي',
  'linear-style': 'بأسلوب Linear',
  'liquid': 'سائل',
  'liquid-glass': 'الزجاج السائل',
  'live-artifact': 'عمل حي',
  'logo': 'شعار',
  'lyubu': 'lyubu',
  'macbook': 'macbook',
  'magnetic': 'مغناطيسي',
  'map': 'خريطة',
  'marketing': 'تسويق',
  'minimal': 'بسيط',
  'mmo': 'mmo',
  'mobile': 'الجوال',
  'money': 'المال',
  'mounted-combat': 'قتال على الخيل',
  'nature': 'الطبيعة',
  'open-world': 'عالم مفتوح',
  'otaku-dance': 'رقصة الأوتاكو',
  'outro': 'الخاتمة',
  'overlay': 'طبقة تراكب',
  'particles': 'جزيئات',
  'pipeline': 'خط المعالجة',
  'portal': 'بوابة',
  'portrait': 'صورة شخصية',
  'pose-reference': 'مرجع الوضعية',
  'product': 'منتج',
  'product-demo': 'عرض المنتج',
  'product-promo': 'ترويج المنتج',
  'rework': 'إعادة معالجة',
  'route': 'مسار',
  'saas': 'saas',
  'sequence': 'تسلسل',
  'shader': 'shader',
  'shatter': 'تحطيم',
  'sizzle': 'مقطع دعائي',
  'social': 'اجتماعي',
  'storyboard': 'لوحة القصة',
  'street-fighter': 'street-fighter',
  'style-transfer': 'نقل النمط',
  'tekken': 'tekken',
  'text': 'نص',
  'three-kingdoms': 'الممالك الثلاث',
  'tiktok': 'tiktok',
  'title-card': 'بطاقة العنوان',
  'transform': 'تحويل',
  'travel': 'سفر',
  'tts': 'tts',
  'typography': 'الطباعة الفنية',
  'unreal-engine-5': 'unreal-engine-5',
  'vertical': 'عمودي',
  'video-reference': 'مرجع الفيديو',
  'vs-screen': 'شاشة المواجهة',
  'webgl': 'webgl',
  'website-to-video': 'من موقع ويب إلى فيديو',
  'wuxia': 'ووشيا',
  'zhaoyun': 'zhaoyun',
};

export const AR_PROMPT_TEMPLATE_COPY: Record<string, Partial<Pick<PromptTemplateSummary, 'summary' | 'title'>>> = {
  '3d-stone-staircase-evolution-infographic': {
    title: 'إنفوجرافيك تطوري على درج حجري ثلاثي الأبعاد',
    summary:
      'يحوّل خطاً زمنياً تطورياً مسطّحاً إلى إنفوجرافيك واقعي على هيئة درج حجري ثلاثي الأبعاد مع عرض تفصيلي للكائنات الحية ولوحات جانبية منظّمة.',
  },
  'anime-martial-arts-battle-illustration': {
    title: 'رسم توضيحي لمعركة فنون قتالية بأسلوب الأنمي',
    summary:
      'يولّد رسماً توضيحياً ديناميكياً وعالي التأثير بأسلوب الأنمي لشخصيتين أنثويتين تتقاتلان في دوجو تقليدي مع تأثيرات طاقة العناصر.',
  },
  'e-commerce-live-stream-ui-mockup': {
    title: 'نموذج واجهة بث مباشر للتجارة الإلكترونية',
    summary:
      'يولّد واجهة بث مباشر واقعية لوسائل التواصل الاجتماعي تتراكب فوق صورة شخصية، وتتضمن رسائل دردشة قابلة للتخصيص، ونوافذ منبثقة للهدايا، وبطاقة شراء منتج.',
  },
  'game-screenshot-anime-fighting-game-captain-ryuuga-vs-kaze-renshin': {
    title: 'لقطة شاشة من لعبة - لعبة قتال بأسلوب الأنمي: Captain Ryuuga ضد Kaze Renshin',
    summary:
      'صورة مفتاحية / لقطة قتال داخل لعبة قتال بأسلوب فن مقدمة Street Fighter 6 أو Tekken 8. محاربان ذكران بأسلوب الأنمي يتواجهان في وسط فناء معبد صيني درامي ليلاً — على اليسار قرصان عاري الصدر يرتدي قبعة من القش مع هالة نارية برتقالية-حمراء دافئة، وعلى اليمين فنان قتالي بشعر مدبّب يرتدي بدلة غي برتقالية يشحن كرة طاقة برق زرقاء ضخمة متطايرة الشرر. يأتي مع واجهة استخدام كاملة للعبة قتال (شريطا صحة مزدوجان، مؤقت الجولة، لوحتا صورة P1/P2 مع أسماء المقاتلين والشعارات، عدادات الكومبو لكل جانب وأقصى المقاييس). تدرّج لوني منقسم بين البرتقالي الدافئ والأزرق البارد يطابق عُرف المقاتلين المتنافسين في هذا النوع. مضبوط لـ gpt-image-2 بنسبة 16:9.',
  },
  'game-screenshot-three-kingdoms-guanyu-slaying-yanliang': {
    title: 'لقطة شاشة من لعبة - لعبة ARPG عن الممالك الثلاث: Guan Yu يقتل Yan Liang',
    summary:
      'لقطة شاشة داخل لعبة أكشن آر بي جي للمشهد الأيقوني من الممالك الثلاث حيث يمتطي Guan Yu حصانه الحربي Red Hare عبر ساحة معركة تحت أمطار غزيرة ويندفع نحو الجنرال المعادي Yan Liang. مُقدّم بالأسلوب السينمائي الواقعي للعبة Black Myth: Wukong، وUnreal Engine 5، مع كاميرا تتبّع بمنظور الشخص الثالث من خلف البطل الممتطي وعلى يساره. واجهة استخدام كاملة لمعركة الزعيم (صورة شخصية، خريطة مصغّرة بنقاط أعداء كثيفة، شريط مهارات سريع مع نداء للضربة القاضية، وشريط صحة طافٍ للزعيم على الجنرال المعادي) تحوّل المشهد إلى لحظة قتال ARPG بمستوى AAA. مضبوط لـ gpt-image-2 بنسبة 16:9.',
  },
  'game-screenshot-three-kingdoms-lyubu-yuanmen-archery': {
    title: 'لقطة شاشة من لعبة - لعبة ARPG عن الممالك الثلاث: رماية Lü Bu عند Yuanmen',
    summary:
      'لقطة شاشة داخل لعبة أكشن آر بي جي للمشهد الشهير من الممالك الثلاث حيث يرمي Lü Bu حربة بعيدة عند بوابة المعسكر لإيقاف معركة. مُقدّم بالأسلوب السينمائي الواقعي للعبة Black Myth: Wukong، وUnreal Engine 5 بتقنيتي Nanite/Lumen، مع كاميرا لعب بمنظور الشخص الثالث فوق الكتف. تراكب واجهة استخدام كامل داخل اللعبة (شريطا الصحة والـ qi، خريطة مصغّرة، شريط مهارات سريع، علامة تثبيت الهدف مع قراءة المسافة إلى الحربة البعيدة) يجعلها تبدو كالتقاطة حقيقية للعبة ARPG من الجيل التالي بدلاً من مشهد سينمائي. مضبوط لـ gpt-image-2 بنسبة 16:9.',
  },
  'game-screenshot-three-kingdoms-zhaoyun-cradle-escape': {
    title: 'لقطة شاشة من لعبة - لعبة ARPG عن الممالك الثلاث: هروب Zhao Yun وهو يحتضن الرضيع عند Changbanpo',
    summary:
      'لقطة شاشة داخل لعبة أكشن آر بي جي للمشهد الأسطوري من الممالك الثلاث حيث يحتضن Zhao Yun الرضيع Liu Chan بذراع واحدة ويشق طريقه عبر صفوف الأعداء برمح في الذراع الأخرى عند Changbanpo. مُقدّم بالأسلوب السينمائي الواقعي للعبة Black Myth: Wukong ممزوجاً بـ Elden Ring، وUnreal Engine 5 مع Nanite الكامل، وتتبّع الأشعة بتقنية Lumen، وأشعة ضوئية حجمية. يتعزز الجوهر العاطفي — ذراع تحمي الطفل الملفوف وذراع تقاتل من أجل الحياة — بتراكب واجهة استخدام كامل يتضمن شريط حماية مخصصاً للمرافقة (ESCORT) للطفل، وعداد كومبو، ونوافذ منبثقة لأرقام الضرر في الهواء على الأعداء المقذوفين. مضبوط لـ gpt-image-2 بنسبة 16:9.',
  },
  'game-ui-ancient-china-open-world-mmo-hud': {
    title: 'واجهة لعبة - واجهة استخدام لـ MMO عالم مفتوح في الصين القديمة',
    summary:
      'يولّد نموذج لقطة شاشة لواجهة استخدام داخل لعبة MMO عالم مفتوح بمستوى AAA عن الصين القديمة، بالأسلوب السينمائي الواقعي للعبة Black Myth: Wukong. بطلة سيّافة جميلة تتصدّر مركز الإطار في مشهد ضريح جبلي قديم ضبابي، محاطة بواجهة استخدام MMO كاملة: صورة شخصية أعلى اليسار مع أشرطة HP/MP/التحمّل وأيقونات التعزيزات، شريط مهارات سريع أسفل الوسط بأيقونات مهارات بخط الكاليغرافيا الصينية، خريطة مصغّرة أعلى اليمين مع علامات المهام، لوحة متعقّب مهام على الجانب الأيمن، نافذة دردشة متمرّرة أسفل اليسار، لوحات أسماء طافية لشخصيات NPC في فضاء العالم وعلامة تعجب للمهمة. مُقدّم كلقطة شاشة واقعية على شاشة عرض، بنسبة 16:9، مناسب لعروض الترويج، والفن المفتاحي بأسلوب gamescom، وإعلانات الألعاب التشويقية على Xiaohongshu/bilibili.',
  },
  'illustrated-city-food-map': {
    title: 'خريطة طعام مدينة مرسومة توضيحياً',
    summary:
      'يولّد خريطة سياحية مرسومة باليد بأسلوب الألوان المائية تتضمن أطباقاً محلية مرقّمة، ومعالم بارزة، ووسيلة إيضاح.',
  },
  'illustration-crayon-kid-drawing-rework': {
    title: 'رسم توضيحي - إعادة صياغة رسمة طفل بأقلام التلوين الشمعية',
    summary:
      'أمر لنقل الأسلوب يعيد صياغة أي صورة مرجعية (لقطة منتج، لقطة شاشة، صورة شخصية، نموذج واجهة مستخدم) إلى رسم يدوي بأقلام التلوين الشمعية يبدو وكأن طفلاً في العاشرة من عمره قد رسمه. يستبدل لوحة الألوان الأصلية بألوان شمعية زاهية ومرحة على ورق أبيض نظيف، ويرش لمسات طفولية بريئة — قلاع وحلوى ونجوم وغيوم وأقواس قزح — لتعزيز الأجواء البريئة المستوحاة من كتب القصص. يعمل كتعديل من صورة إلى صورة في GPT-image-2 (يتطلب رفع صورة مرجعية مع الأمر)؛ مناسب جداً للقطات شاشة المواقع، والرسوم الرئيسية للعلامة التجارية، وصور المنتجات، والصور الشخصية.',
  },
  'infographic-otaku-dance-choreography-breakdown-gokurakujodo-16-panels': {
    title: 'إنفوغرافيك - تحليل تصميم رقصة الأوتاكو (Gokuraku Jodo، 16 لوحة)',
    summary:
      'ملصق عمودي واحد بنسبة 2:3 مكوّن كشبكة 4×4 من 16 لوحة مربعة متصلة، تشكّل مخطط تحليل كامل لتصميم رقصة أغنية الأوتاكو اليابانية الشهيرة 極楽浄土 (Gokuraku Jodo). تُظهر كل لوحة الفتاة نفسها، فتاة أنمي معبودة لطيفة شبه واقعية (ذيلان ورديان، زي معبودة مدرسية بياقة بحرية) وهي تؤدي وضعية مميزة واحدة من الرقصة، بكامل الجسم، على خلفية وردية باستيل مع شريط تعليق ياباني صغير في الأسفل ودائرة مرقّمة في أعلى اليسار. مصمّم صراحةً كورقة مرجعية للوضعيات لتوليد الفيديو بالذكاء الاصطناعي — كل ظل واضح ولا لبس فيه، بلا خطوط حركة أو فوضى في الخلفية. مضبوط لـ gpt-image-2، نسبة 2:3. الفئة: إنفوغرافيك.',
  },
  'momotaro-explainer-slide-in-hybrid-style': {
    title: 'شريحة شرح Momotaro بأسلوب هجين',
    summary:
      'أمر يمزج بين الجماليات البسيطة والدافئة لرسوم Irasutoya وكثافة المعلومات العالية التي تميّز الشرائح الحكومية اليابانية.',
  },
  'notion-team-dashboard-live-artifact': {
    title: 'لوحة معلومات فريق بأسلوب Notion (عمل حي تفاعلي)',
    summary:
      'نموذج لوحة معلومات فريق بأسلوب Notion على شاشة واحدة — شبكة مؤشرات أداء، وخط بياني مصغّر لسبعة أيام، وموجز نشاط، وجدول مهام مرتبط بقاعدة بيانات. مرافق بصري لمهارة العمل الحي؛ اقرنه بها للتشغيلات القابلة للتحديث / المدعومة بالموصّلات، أو استخدمه بمفرده كنموذج ثابت.',
  },
  'profile-avatar-anime-girl-to-cinematic-photo': {
    title: 'ملف شخصي / صورة رمزية - من فتاة أنمي إلى صورة سينمائية',
    summary:
      'يحوّل هذا الأمر رسماً مرجعياً لشخصية إلى صورة شخصية داخلية كلاسيكية واقعية بألوان دافئة، مع الحفاظ على الزي والوضعية والقطة الأصلية.',
  },
  'profile-avatar-casual-fashion-grid-photoshoot': {
    title: 'ملف شخصي / صورة رمزية - جلسة تصوير أزياء كاجوال بشبكة صور',
    summary:
      'أمر JSON منظّم لكولاج من 4 صور لجلسة تصوير أزياء كاجوال مع معايير مفصّلة للشخص والإضاءة.',
  },
  'profile-avatar-cinematic-south-asian-male-portrait-with-vultures': {
    title: 'ملف شخصي / صورة رمزية - صورة سينمائية لرجل من جنوب آسيا مع نسور',
    summary:
      'صورة سينمائية مفصّلة لشاب من جنوب آسيا في أجواء خيالية مظلمة وكئيبة محاطاً بالنسور والغربان.',
  },
  'profile-avatar-cyberpunk-anime-portrait-with-neon-face-text': {
    title: 'ملف شخصي / صورة رمزية - صورة أنمي سايبربانك مع نص نيون على الوجه',
    summary:
      'صورة أنمي أنيقة مغمورة بالنيون للملصقات أو فنون وسائل التواصل الاجتماعي أو الهويات البصرية المستقبلية.',
  },
  'profile-avatar-elegant-fantasy-girl-in-violet-garden': {
    title: 'ملف شخصي / صورة رمزية - فتاة خيالية أنيقة في حديقة بنفسجية',
    summary:
      'يولّد هذا الأمر صورة خيالية مصقولة بأسلوب الأنمي لامرأة أنيقة بشعر منسّق لامع، وملابس بنفسجية-سوداء مزخرفة، وحديقة سحرية مليئة بالأزهار، مثالية للشخصيات',
  },
  'profile-avatar-ethereal-blue-haired-fantasy-portrait': {
    title: 'ملف شخصي / صورة رمزية - صورة خيالية أثيرية لشخصية ذات شعر أزرق',
    summary:
      'يولّد هذا الأمر صورة شخصية خيالية ناعمة ومضيئة بأسلوب الأنمي، مثالية لإنشاء فن رئيسي عمودي أنيق أو رسوم شخصيات بشعر متدفّق وأجواء ربيعية حالمة.',
  },
  'profile-avatar-glamorous-woman-in-black-portrait': {
    title: 'ملف شخصي / صورة رمزية - صورة لامرأة فاتنة باللون الأسود',
    summary:
      'يولّد هذا الأمر صورة فاخرة واقعية لامرأة أنيقة بزي أسود ذي فتحة عميقة، مثالية للتصوير الافتتاحي للأزياء أو صور الجمال.',
  },
  'profile-avatar-hyper-realistic-selfie-texture-prompts': {
    title: 'ملف شخصي / صورة رمزية - أوامر ملمس سيلفي شديدة الواقعية',
    summary:
      'مقتطفات أوامر مفصّلة لتوليد ملمس بشرة واقعي وتأطير سيلفي أصيل من الهاتف، مع التركيز على المسامات المرئية والإضاءة الطبيعية.',
  },
  'profile-avatar-lavender-fantasy-mage-portrait': {
    title: 'ملف شخصي / صورة رمزية - صورة ساحرة خيالية بلون اللافندر',
    summary:
      'يولّد هذا الأمر صورة خيالية مصقولة بأسلوب الأنمي لأميرة ساحرة أنيقة بشعر أشقر لامع، وأزهار بنفسجية، وزي كريستالي مزخرف، مثالية لفن الشخصيات أو الرسوم السحرية',
  },
  'profile-avatar-monochrome-studio-portrait': {
    title: 'ملف شخصي / صورة رمزية - صورة استوديو أحادية اللون',
    summary:
      'أمر تصوير تجاري راقٍ لصورة أحادية اللون بخلفية مقسّمة مميزة وإضاءة استوديو درامية.',
  },
  'profile-avatar-old-photo-restoration-to-dslr-portrait': {
    title: 'ملف شخصي / صورة رمزية - ترميم صورة قديمة إلى صورة بكاميرا DSLR',
    summary:
      'يرمّم هذا الأمر صورة عائلية كلاسيكية تالفة لأربعة أشخاص ويحوّلها إلى صورة واقعية نظيفة وملوّنة وعالية الدقة، لإصلاح الصور وتحسينها.',
  },
  'profile-avatar-poetic-woman-in-garden-portrait': {
    title: 'ملف شخصي / صورة رمزية - صورة شاعرية لامرأة في حديقة',
    summary:
      'يولّد هذا الأمر صورة افتتاحية واقعية لشابة محبة للكتب في حديقة مشمسة، مثالية لتصوير نمط الحياة أو الهويات الأدبية أو صور الشخصيات الأنيقة.',
  },
  'profile-avatar-professional-identity-portrait-wallpaper': {
    title: 'ملف شخصي / صورة رمزية - خلفية صورة هوية مهنية',
    summary:
      'يولّد خلفية فاخرة عالية الدقة تُظهر شخصاً بزي مهني مع أنشطة متعلقة بالمهنة ونصوص طباعية.',
  },
  'profile-avatar-realistically-imperfect-ai-selfie': {
    title: 'ملف شخصي / صورة رمزية - سيلفي ذكاء اصطناعي غير مثالي بواقعية',
    summary:
      'أمر إبداعي يُستخدم مع GPT Image 2 لتوليد سيلفي \'فاشل\' يبدو وكأنه لقطة عرضية منخفضة الجودة من هاتف ذكي.',
  },
  'profile-avatar-signed-marker-portrait-on-shikishi': {
    title: 'ملف شخصي / صورة رمزية - صورة موقّعة بقلم تخطيط على Shikishi',
    summary:
      'يولّد هذا صورة حيوية موقّعة بأسلوب قلم التخطيط على لوح shikishi مربع، مفيدة لتواقيع فن المعجبين، ومنشورات الرسوم التذكارية، وصور الشكر الشخصية.',
  },
  'profile-avatar-snow-rabbit-empress-portrait': {
    title: 'ملف شخصي / صورة رمزية - صورة إمبراطورة أرنب الثلج',
    summary:
      'أمر صورة خيالية واقعية لتوليد امرأة مهيبة بطابع الأرنب ترتدي هانفو شتوياً مزخرفاً وتقف في معبد جبلي مكسوّ بالثلوج.',
  },
  'profile-avatar-snow-rabbit-mask-hanfu-portrait': {
    title: 'ملف شخصي / صورة رمزية - صورة هانفو بقناع أرنب الثلج',
    summary:
      'يولّد هذا الموجّه صورة بورتريه سينمائية بأجواء شتوية خيالية لامرأة مقنّعة ترتدي Hanfu أبيض مستوحى من الأرانب، مثالية لفن الشخصيات الأنيق وصور العرض الفنية المفعمة بالأجواء بالذكاء الاصطناعي.',
  },
  'profile-avatar-snowy-rabbit-hanfu-portrait': {
    title: 'الملف الشخصي / الصورة الرمزية - بورتريه Hanfu الأرنب الثلجي',
    summary:
      'يولّد هذا الموجّه صورة بورتريه فائقة التفاصيل لجمال خيالي لامرأة بأذني أرنب ترتدي Hanfu مطرّزًا، مثالية لفن الشخصيات الأنيق أو تصميم الأزياء أو عروض البورتريهات السينمائية بالذكاء الاصطناعي.',
  },
  'profile-avatar-snowy-rabbit-spirit-portrait': {
    title: 'الملف الشخصي / الصورة الرمزية - بورتريه روح الأرنب الثلجي',
    summary:
      'يولّد هذا الموجّه صورة بورتريه خيالية هادئة لامرأة مجهولة بأذني أرنب في الشتاء، مثالية لفن الشخصيات المفعم بالأجواء ورسوم الملفات الشخصية المنمّقة.',
  },
  'profile-avatar-song-dynasty-hanfu-portrait': {
    title: 'الملف الشخصي / الصورة الرمزية - بورتريه Hanfu من عهد أسرة سونغ',
    summary:
      'موجّه مُحسّن لتوليد صورة بورتريه مفصّلة وواقعية لجميلة ترتدي Hanfu التقليدي من عهد أسرة سونغ داخل فناء قديم.',
  },
  'social-media-post-anime-pokemon-shop-outfit-teaser-poster': {
    title: 'منشور على وسائل التواصل الاجتماعي - ملصق تشويقي لزي متجر Pokémon بأسلوب الأنمي',
    summary:
      'يولّد هذا الموجّه ملصق إعلان أزياء أنمي بألوان باستيل ناعمة يضم فتاة بوجه ضبابي ترتدي فستانًا أزرق داخل متجر Pokémon، مثالي للملصقات التشويقية للكشف عن الأزياء والصور الترويجية للشخصيات.',
  },
  'social-media-post-cinematic-elevator-scene': {
    title: 'منشور على وسائل التواصل الاجتماعي - مشهد مصعد سينمائي',
    summary:
      'موجّه لتوليد مشهد سينمائي بأجواء كئيبة لامرأة داخل مصعد معدني مع إضاءة وانعكاسات واقعية.',
  },
  'social-media-post-confused-elf-girl-at-pastel-desk': {
    title: 'منشور على وسائل التواصل الاجتماعي - فتاة جنية حائرة عند مكتب بألوان باستيل',
    summary:
      'يولّد هذا الموجّه رسمة أنمي بألوان باستيل ناعمة لفتاة جنية تكتب على حاسوبها في مساحة عمل دافئة وظريفة، مثالية للمنشورات الاجتماعية أو الخلفيات أو الفن ذي الطابع المخصص للبثّ المباشر.',
  },
  'social-media-post-editorial-fashion-photography': {
    title: 'منشور على وسائل التواصل الاجتماعي - تصوير أزياء تحريري',
    summary:
      'موجّه بأجواء كئيبة يركّز على الأزياء لمشهد استوديو بسيط بإضاءة ناعمة ودرجات لونية دافئة.',
  },
  'social-media-post-fashion-editorial-collage': {
    title: 'منشور على وسائل التواصل الاجتماعي - كولاج أزياء تحريري',
    summary:
      'موجّه كولاج صور 2×2 شديد التفصيل للقطات أزياء تحريرية، يركّز على تناسق التنسيق وإضاءة محددة وملامح الوجه من صورة مرجعية.',
  },
  'social-media-post-psg-transfer-announcement-poster': {
    title: 'منشور على وسائل التواصل الاجتماعي - ملصق إعلان انتقال إلى PSG',
    summary:
      'ملصق احترافي وجريء للتوقيع في كرة القدم للإعلان عن انتقال لاعب إلى باريس سان جيرمان على وسائل التواصل الاجتماعي أو الرسوميات الترويجية الرياضية.',
  },
  'social-media-post-sensational-girl-dance-storyboard-8-shots': {
    title: 'منشور على وسائل التواصل الاجتماعي - ستوري بورد رقص فتاة مثيرة (8 لقطات)',
    summary:
      'مجموعة موجّهات ستوري بورد كاملة من 8 لقطات لتوليد تسلسل رقص متسق إطارًا بإطار لشخصية أنيقة. تتضمن رموز نمط عامة مشتركة، وموجّهًا سلبيًا قابلًا لإعادة الاستخدام، وثمانية موجّهات لكل لقطة (وضعية الافتتاح، هزّ الورك، موجة الجسم، التواء الخصر عند نزول الإيقاع، تمايل الورك الجانبي، رفّة الشعر، وضعية القوة، الوضعية الختامية). مُعدّ خصيصًا لنماذج فئة GPT-Image-2: مفردات موجزة، دون صياغة حساسة، ولغة تأطير وإضاءة متناسقة عبر اللقطات بحيث تبدو الإطارات وكأنها رقصة واحدة متواصلة.',
  },
  'social-media-post-showa-day-retro-culture-magazine-cover': {
    title: 'منشور على وسائل التواصل الاجتماعي - غلاف مجلة ثقافية رترو ليوم شووا',
    summary:
      'صفحة مقالة دافئة بأسلوب تحريري لعطلة يابانية تجمع بين فن شخصيات الأنمي، وصور شوارع حقبة شووا الحنينية، وتخطيط معلوماتي بأسلوب المجلات للترويجات الثقافية الموسمية.',
  },
  'social-media-post-social-media-fashion-outfit-generation': {
    title: 'منشور على وسائل التواصل الاجتماعي - توليد أزياء لوسائل التواصل الاجتماعي',
    summary:
      'موجّه لتوليد توصيات أزياء بأسلوب مدوّني الموضة تكفي لأسبوع كامل بناءً على ملف شخصية، مكتملة بأسماء العناصر وأسعارها.',
  },
  'social-media-post-travel-snapshot-collage-prompt': {
    title: 'منشور على وسائل التواصل الاجتماعي - موجّه كولاج لقطات السفر',
    summary:
      'موجّه مفصّل لإنشاء كولاج حنيني من 12 إطارًا لصور سفر بأسلوب الهاتف الذكي تصوّر رحلة منفردة.',
  },
  'social-media-post-vintage-sign-painter-sketch': {
    title: 'منشور على وسائل التواصل الاجتماعي - رسم تخطيطي عتيق لرسّام اللافتات',
    summary:
      'يولّد رسمًا تخطيطيًا مرسومًا يدويًا بالقلم اللبّادي على الورق بتفاصيل واقعية مثل خطوط الجرافيت وتسرّب الحبر، مثالي لأنماط الخط العتيقة.',
  },
  'vr-headset-exploded-view-poster': {
    title: 'ملصق عرض مفكّك لسماعة VR',
    summary:
      'يولّد مخططًا تقنيًا متقدمًا بعرض مفكّك لسماعة VR مع وسائل شرح مفصّلة للمكوّنات ونص ترويجي.',
  },
  '3d-animated-boy-building-lego': {
    title: 'صبي ثلاثي الأبعاد متحرك يبني Lego',
    summary:
      'موجّه فيديو متعدد اللقطات بأسلوب الرسوم المتحركة ثلاثية الأبعاد يصف صبيًا يجمّع قطع Lego بعناية في غرفة، مع تأثيرات التصوير الزمني المتسارع.',
  },
  'a-decade-of-refinement-glow-up': {
    title: 'عقد من التحسين والتألق',
    summary:
      'موجّه تحوّل لـ Seedance 2.0 يُظهر انتقال رجل من أجواء عادية عام 2016 إلى نمط حياة فاخر في دبي عام 2026 مع الحفاظ على تناسق الشخصية.',
  },
  'ancient-guardian-dragon-rescue': {
    title: 'إنقاذ التنين الحارس القديم',
    summary:
      'موجّه سينمائي مفصّل متعدد اللقطات لقصة عن فتاة في قرية ممطرة ينقذها تنين ناشئ، يركّز على المؤثرات البصرية والصوت المفعم بالأجواء.',
  },
  'ancient-indian-kingdom-fpv-video': {
    title: 'فيديو FPV لمملكة هندية قديمة',
    summary:
      'موجّه سينمائي سريع الإيقاع بأسلوب طائرة FPV يصوّر مملكة هندية أسطورية بمعابد وأدغال.',
  },
  'animation-transfer-and-camera-tracking-prompt': {
    title: 'موجّه نقل الرسوم المتحركة وتتبّع الكاميرا',
    summary:
      'موجّه تقني لـ Seedance 2.0 يطبّق مرجع حركة محدّد على شخصية مع الحفاظ على تتبّع كاميرا ثابت.',
  },
  'beat-synced-outfit-transformation-dance': {
    title: 'رقصة تبديل أزياء متزامنة مع الإيقاع',
    summary:
      'موجّه لـ Seedance 2.0 ينسّق رقصة شخصية تتبع إطارات التفصيل مع أداء تبديل أزياء متزامن مع الإيقاع.',
  },
  'character-intro-motion-graphics-sequence': {
    title: 'تسلسل رسوميات حركية للتعريف بالشخصية',
    summary:
      'موجّه رسوميات حركية معقّد متعدّد المراحل للتعريف بفريق من الشخصيات مع طبقات واجهة مستخدم وانتقالات محدّدة، مصمّم لنموذج Seedance 2.0.',
  },
  'cinematic-birthday-celebration-sequence': {
    title: 'تسلسل احتفال عيد ميلاد سينمائي',
    summary:
      'موجّه فيديو متعدّد اللقطات بالغ التفصيل لتسلسل عيد ميلاد، يركّز على اتّساق الشخصية وسرد القصص العاطفي.',
  },
  'cinematic-dragon-interaction-flight': {
    title: 'تفاعل سينمائي مع تنّين وطيران',
    summary:
      'موجّه مفصّل بأسلوب لوحة قصصية لفيديو يصوّر تفاعلاً عاطفياً لامرأة مع تنّين يتبعه تسلسل طيران سينمائي.',
  },
  'cinematic-east-asian-woman-hand-dance': {
    title: 'رقصة يدين سينمائية لامرأة من شرق آسيا',
    summary:
      'موجّه فيديو سينمائي بالغ التفصيل متعدّد اللقطات لرقصة يدين مصمّمة بأسلوب فني، يتضمّن تعليمات موقّتة لحركة الكاميرا وأفعال الشخصية.',
  },
  'cinematic-emotional-face-close-up': {
    title: 'لقطة وجه عاطفية سينمائية مقرّبة',
    summary:
      'موجّه تقني بالغ التفصيل لـ Seedance 2.0 يركّز على ملامس بشرة واقعية وسلسلة من التحوّلات الوجهية العاطفية المعقّدة.',
  },
  'cinematic-marine-biologist-exploration': {
    title: 'استكشاف سينمائي لعالم أحياء بحرية',
    summary:
      'موجّه فيديو سينمائي مفصّل لمشهد تحت الماء يصوّر عالم أحياء بحرية يكتشف حطام سفينة قديمة في شعاب مرجانية.',
  },
  'cinematic-music-podcast-and-guitar-technique': {
    title: 'بودكاست موسيقي سينمائي وتقنية عزف الغيتار',
    summary:
      'موجّه سينمائي متقدّم لتوليد فيديو بودكاست موسيقي بدقة 4K، مع تركيز محدّد على تقنية عزف الغيتار، والهارمونيكس القرصي، وجماليات الأستوديو.',
  },
  'cinematic-route-navigation-guide': {
    title: 'دليل ملاحة سينمائي للمسار',
    summary:
      'موجّه مهيكل متعدّد المشاهد مصمّم لـ Seedance لإنشاء فيديو ملاحة سير متّسق يصوّر شخصية مرشد سياحي متكرّرة وانتقالات سلسة بين مواقع واقعية.',
  },
  'cinematic-street-racing-sequence-for-seedance-2': {
    title: 'تسلسل سباق شوارع سينمائي لـ Seedance 2',
    summary:
      'موجّه مفصّل متعدّد اللقطات مصمّم لـ Seedance 2 لتوليد تسلسل سباق شوارع سينمائي ليلاً، يركّز على تركيز السائق الشديد، وعمل كاميرا ديناميكي، وتسارع انفجاري، مهيكل',
  },
  'cinematic-vampire-alley-fight-sequence': {
    title: 'تسلسل قتال مصّاصي دماء سينمائي في زقاق',
    summary:
      'موجّه أكشن شامل لمشهد فيلم قصير يتضمّن حركات كاميرا ديناميكية وقتالاً فائق السرعة في زقاق مضاء بالنيون.',
  },
  'crimson-horizon-sci-fi-cinematic-sequence': {
    title: 'تسلسل خيال علمي سينمائي بعنوان Crimson Horizon',
    summary:
      'تسلسل فيديو سينمائي شامل من 9 لقطات لفيلم خيال علمي بعنوان \'Crimson Horizon\'، يفصّل كل شيء من إطلاق صاروخ إلى لقاء فضائي مرعب على المرّيخ.',
  },
  'cyberpunk-game-trailer-script': {
    title: 'نص إعلان تشويقي للعبة سايبربانك',
    summary:
      'موجّه توليد فيديو موسّع لإعلان تشويقي للعبة سايبربانك، يفصّل تصميم الشخصيات، ورسوم واجهة المستخدم المتحرّكة، والانتقالات البيئية من فراغ أبيض إلى حي فقير.',
  },
  'forbidden-city-cat-satire': {
    title: 'سخرية قط المدينة المحرّمة',
    summary:
      'موجّه كوميديا سوداء معقّد لـ Seedance 2.0 يصوّر قطاً برتقالياً مسؤولاً وإمبراطوراً ضبعاً في إطار ساخر من عهد أسرة تشينغ.',
  },
  'hollywood-haute-couture-fantasy-video-prompt': {
    title: 'موجّه فيديو خيالي لأزياء هوليوود الراقية',
    summary:
      'موجّه توليد فيديو مفصّل متعدّد المشاهد لـ Seedance 2.0، مصمّم لإنشاء فيلم خيالي بأزياء هوليوود الراقية. يحدّد الموجّه الأسلوب، والدقة (8K)، ومحرّك التصيير (Unreal Engin',
  },
  'hunched-character-animation': {
    title: 'رسوم متحرّكة لشخصية منحنية الظهر',
    summary:
      'تعليمات لـ Seedance 2 لإنشاء رسوم متحرّكة للسير في المكان لمرجع شخصية محدّد.',
  },
  'hyperframes-html-in-canvas-iphone-device': {
    title: 'HyperFrames HTML-in-Canvas: عرض منتج ثلاثي الأبعاد لـ iPhone + MacBook',
    summary:
      'عرض منتج مدّته 15 ثانية حيث يطفو جهازا iPhone 15 Pro Max و MacBook Pro حقيقيان بصيغة GLTF على منصّة نظيفة مع تصيير واجهة التطبيق الفعلية مباشرةً على شاشتيهما عبر drawElementImage. توهّج عدسة زجاجي متحوّل + منصّة دوّارة 360°. مبني على كتلة كتالوج vfx-iphone-device.',
  },
  'hyperframes-html-in-canvas-text-cursor': {
    title: 'HyperFrames HTML-in-Canvas: كشف نصي سينمائي بمؤشّر',
    summary:
      'كشف نصي درامي مدّته 8 ثوانٍ مع توهّج مؤشّر، وأشعّة ظلّ كروماتيكية، وإضاءة موجّهة على منصّة سوداء. طباعة DOM حقيقية تحت معالجة لاحقة حيّة بالشيدر. مبني على كتلة كتالوج vfx-text-cursor.',
  },
  'hyperframes-html-in-canvas-shatter': {
    title: 'HyperFrames HTML-in-Canvas: خاتمة بتحطّم زجاجي',
    summary:
      'خاتمة تحطّم HTML مدّتها 12 ثانية — تثبت صفحة منتج حقيقية أو بطاقة تسعير للحظة، ثم تنفجر إلى شظايا زجاجية منكسرة الضوء مع ضبابية عمق وتشتّت كروماتيكي. مبنية على كتلة كتالوج vfx-shatter. تُستخدم كبطاقة ختامية بعد تركيب أطول.',
  },
  'hyperframes-html-in-canvas-liquid-background': {
    title: 'HyperFrames HTML-in-Canvas: خلفية بطل سائلة',
    summary:
      'مشهد افتتاحي مدته 12 ثانية بمحتوى HTML يطفو فوق سطح سائل عضوي — مستوٍ مقسَّم بإزاحة الرؤوس، وديناميكيات موجية في الوقت الفعلي، مع طبقة DOM ملتقطة في الأعلى واضحة وقابلة للقراءة. مبني على كتلة الكتالوج vfx-liquid-background.',
  },
  'hyperframes-html-in-canvas-liquid-glass': {
    title: 'HyperFrames HTML-in-Canvas: كشف افتتاحي بزجاج سائل',
    summary:
      'كشف بزجاج سائل بنمط voronoi مدته 20 ثانية لصفحة هبوط منتج حقيقية — يُلتقط DOM مباشرةً عبر drawElementImage، ثم يتحطم إلى خلايا زجاجية كاسرة للضوء، وأخيرًا يستقر في لقطة افتتاحية نظيفة. مبني على كتلة الكتالوج vfx-liquid-glass.',
  },
  'hyperframes-html-in-canvas-magnetic': {
    title: 'HyperFrames HTML-in-Canvas: تصوّر المجال المغناطيسي',
    summary:
      'تصوّر جسيمات المجال المغناطيسي مدته 15 ثانية يتفاعل مع خريطة حرارية أو مخطط DOM حي — تتتبع الجسيمات خطوط المجال التي تنحني حول محتوى HTML الملتقَط، مثالي لمنتجات تعلّم الآلة والبيانات. مبني على كتلة الكتالوج vfx-magnetic.',
  },
  'hyperframes-html-in-canvas-portal-reveal': {
    title: 'HyperFrames HTML-in-Canvas: لوحة بيانات بكشف بوابي',
    summary:
      'بوابة بُعدية مدتها 10 ثوانٍ تنفتح على لوحة بيانات حية — يُلتقط DOM في الوقت الفعلي، مع انسكاب ضوئي حجمي وجسيمات على حافة البوابة. مبني على كتلة الكتالوج vfx-portal. مصمَّم للقطات بيانات افتتاحية بأسلوب العروض التقديمية الرئيسية.',
  },
  'hyperframes-money-counter-hype': {
    title: 'HyperFrames: عدّاد أموال مثير $0 ← $10K (9:16)',
    summary:
      'مقطع HyperFrames مثير عمودي مدته 6 ثوانٍ بدقة 1080×1920 — عدّاد بأسلوب Apple من $0 إلى $10,000 مع وميض أخضر، وجسيمات انفجار أموال، وأيقونة كومة نقود، وعنوان جذّاب. مبني على كتلة الكتالوج `apple-money-count` في HyperFrames.',
  },
  'hyperframes-app-showcase-three-phones': {
    title: 'HyperFrames: عرض تطبيق مدته 12 ثانية — ثلاثة هواتف طافية',
    summary:
      'تكوين عرض تطبيق مدته 12 ثانية بنسبة 16:9 — ثلاث شاشات iPhone طافية تحوم في فضاء ثلاثي الأبعاد، تدور كل واحدة بدورها لإبراز ميزة مختلفة، مع تسميات تظهر متزامنة مع الإيقاع، وتثبيت شعار في النهاية. مبني مباشرةً على كتلة الكتالوج `app-showcase` في HyperFrames.',
  },
  'hyperframes-brand-sizzle-reel': {
    title: 'HyperFrames: مقطع ترويجي مدته 30 ثانية للعلامة التجارية',
    summary:
      'مقطع ترويجي HyperFrames مدته 30 ثانية بنسبة 16:9 — قطعات سريعة، وطباعة حركية متزامنة مع الإيقاع، وتحجيم متفاعل مع الصوت على الكلمات المعروضة، وانتقالات shader بين خمسة مشاهد، وبطاقة ختامية مع توهّج الشعار. مصمَّم على غرار النموذج aisoc-hype من حقيبة الطلاب.',
  },
  'hyperframes-saas-product-promo-30s': {
    title: 'HyperFrames: ترويج منتج SaaS مدته 30 ثانية (بأسلوب Linear)',
    summary:
      'تكوين HyperFrames مدته 30 ثانية مصمَّم على غرار الأفلام الترويجية للمنتجات بأسلوب Linear/ClickUp — كشوفات ثلاثية الأبعاد لواجهة المستخدم، وطباعة حركية متزامنة مع الإيقاع، ولقطات شاشة متحركة للواجهة، وبطاقة ختامية مع شعار الخروج. مبني من كتل كتالوج HF (ui-3d-reveal و app-showcase و logo-outro) إضافةً إلى انتقالات shader بين المشاهد.',
  },
  'hyperframes-logo-outro-cinematic': {
    title: 'HyperFrames: شعار خروج سينمائي مدته 4 ثوانٍ',
    summary:
      'شعار خروج مدته 4 ثوانٍ بنسبة 16:9 — تجميع للعلامة النصية قطعة بقطعة مع توهّج، ومسح لامع عبر التثبيت النهائي، وطبقة حُبيبات ناعمة، ودعوة لاتخاذ إجراء بسطر واحد. مبني على كتل HyperFrames `logo-outro` و `shimmer-sweep` و `grain-overlay`.',
  },
  'hyperframes-product-reveal-minimal': {
    title: 'HyperFrames: كشف منتج بسيط مدته 5 ثوانٍ',
    summary:
      'تكوين HyperFrames مدته 5 ثوانٍ لكشف منتج راقٍ — لوحة داكنة، ولون مميز دافئ واحد، وبطاقة عنوان بتقريب بطيء، وسطر جذّاب حركي، وحركة مقتصدة. يقوم العميل بإنتاج MP4 من HTML+GSAP عبر puppeteer؛ لا حاجة إلى لقطات جاهزة.',
  },
  'hyperframes-social-overlay-stack': {
    title: 'HyperFrames: مجموعة تراكب اجتماعية 9:16 (X · Reddit · Spotify · Instagram)',
    summary:
      'تكوين HyperFrames عمودي مدته 15 ثانية بدقة 1080×1920 يكدّس أربع بطاقات اجتماعية متحركة فوق حلقة كاميرا للوجه — منشور X، وردّ فعل Reddit، وبطاقة "قيد التشغيل الآن" من Spotify، ودعوة لمتابعة Instagram في النهاية. كل بطاقة هي كتلة كتالوج من HyperFrames؛ والقيمة المضافة هي التنسيق الحركي.',
  },
  'hyperframes-tiktok-karaoke-talking-head': {
    title: 'HyperFrames: مقطع TikTok 9:16 بتعليق صوتي مع تسميات كاريوكي',
    summary:
      'مقطع HyperFrames قصير عمودي بدقة 1080×1920 — تعليق صوتي بتقنية TTS فوق حلقة كاميرا للوجه، مع تسميات بأسلوب الكاريوكي متزامنة مع الكلمات، وشريط سفلي متحرك، وتراكب لمتابعة tiktok في النهاية. يعكس النموذج may-shorts-19 من حقيبة طلاب HyperFrames.',
  },
  'hyperframes-data-bar-chart-race': {
    title: 'HyperFrames: سباق مخطط أعمدة متحرك (بأسلوب NYT)',
    summary:
      'رسم بياني للبيانات مدته 12 ثانية بنسبة 16:9 — مخطط أعمدة وخطوط متحرك مع كشف متدرّج للفئات، وعنوان بخط serif بأسلوب NYT، ومصدر في الحاشية، وتسميات قيم حركية. مبني مباشرةً على كتلة الكتالوج `data-chart` في HyperFrames.',
  },
  'hyperframes-flight-map-route': {
    title: 'HyperFrames: خريطة رحلة طيران بأسلوب Apple (المنشأ ← الوجهة)',
    summary:
      'خريطة مسار طيران سينمائية مدتها 8 ثوانٍ بنسبة 16:9 — تقريب واقعي للتضاريس، وطائرة متحركة تنزلق من المنشأ إلى الوجهة على طول مسار منحنٍ، ومدن مُسمّاة، وعدّاد مسافة حركي. مبني مباشرةً على كتلة الكتالوج `nyc-paris-flight` في HyperFrames، وقابل لإعادة الاستخدام لأي زوج من المدن.',
  },
  'hyperframes-website-to-video-promo': {
    title: 'HyperFrames: خط أنابيب من موقع إلى فيديو (مقطع تسويقي مدته 15 ثانية)',
    summary:
      'تكوين HyperFrames مدته 15 ثانية بنسبة 16:9 يلتقط موقعًا حيًّا بثلاثة أحجام عرض، ثم يحرّك بينها بانقسام شعاعي لوني بين المشاهد. يعكس النموذج hyperframes-sizzle من حقيبة الطلاب حيث يكون الموقع هو المصدر الأصلي.',
  },
  'live-action-anime-adaptation-water-vs-thunder-breathing-duel': {
    title: 'اقتباس أنمي بأداء حي: نزال تنفّس الماء ضد تنفّس الرعد',
    summary:
      'موجّه عالي التفصيل مدته 15 ثانية لتوليد اقتباس بأداء حي لنزال بأسلوب الأنمي، يضم \'تنفّس الماء\' (تنين ماء أزرق) في مواجهة \'تنفّس الرعد\' (برق ذهبي). الـ p',
  },
  'luxury-supercar-cinematic-narrative': {
    title: 'سرد سينمائي لسيارة خارقة فاخرة',
    summary:
      'موجّه سينمائي متعدد اللقطات عالي التفصيل لـ Seedance 2.0 يضم رجلاً أنيقًا وكلاب دوبرمان وسيارة خارقة عتيقة في أجواء جبلية ضبابية.',
  },
  'magical-academy-storyboard-sequence': {
    title: 'تسلسل لوحة قصصية لأكاديمية سحرية',
    summary:
      'موجّه مفصّل بأسلوب اللوحة القصصية لتسلسل سينمائي يصوّر فتاة سحرية في أكاديمية، يغطّي الوصول واكتشاف القوة ونزالًا سحريًا.',
  },
  'modern-rural-aesthetics-healing-short-film-video-prompt': {
    title: 'موجّه فيديو لفيلم قصير هادئ بجماليات الريف العصري',
    summary:
      'موجّه مفصّل من ثلاث لقطات لـ Seedance 2.0 لتوليد فيلم قصير سينمائي هادئ بأسلوب جماليات الريف العصري. يحدّد الأسلوب (إعلان سينمائي، 4K/8K، ماكرو متطرف، طبيعي)',
  },
  'nightclub-flyer-atmospheric-animation': {
    title: 'رسوم متحركة لأجواء منشور ملهى ليلي',
    summary:
      'موجّه رسوم متحركة دقيق لـ Seedance 2.0 لبثّ الحياة في عناصر الخلفية والإضاءة مع إبقاء الموضوع ثابتًا',
  },
  'retro-hk-wuxia-film-aesthetic': {
    title: 'جماليات أفلام الكونغ فو الكلاسيكية من هونغ كونغ',
    summary:
      'موجه فيديو معقد متعدد الأجزاء يعيد إنتاج جماليات أفلام الكونغ فو (Wuxia) في هونغ كونغ من ثمانينيات وتسعينيات القرن الماضي، ويتضمن تحول شخصية من قطة إلى إنسان بلقطات أسلوبية.',
  },
  'seedance-2-0-15-second-cinematic-japanese-romance-short-film': {
    title: 'Seedance 2.0: فيلم رومانسي ياباني سينمائي قصير مدته 15 ثانية',
    summary:
      'موجه شديد التفصيل ومتعدد المشاهد مدته 15 ثانية لـ Seedance 2.0، مصمم لتوليد فيلم قصير سينمائي فائق الواقعية عن الحب البريء في مدرسة ثانوية يابانية. يحدد الموجه إعداد المشهد (فارغ',
  },
  'seedance-2-0-80-year-old-rapper-mv': {
    title: 'Seedance 2.0: فيديو موسيقي لمغني راب عمره 80 عامًا',
    summary:
      'موجه مفصّل مدته 15 ثانية لـ Seedance 2.0 لتوليد فيديو موسيقي (MV) أفقي بنسبة 16:9 لراب الشوارع يتضمن امرأة عمرها 80 عامًا. يحدد الموجه الأسلوب (درجات لونية باردة بنفسجية/زرقاء نيون، exp',
  },
  'sequence-and-movement-instruction-for-martial-arts-video': {
    title: 'تعليمات التسلسل والحركة لفيديو فنون قتالية',
    summary:
      'موجه فيديو لـ Seedance 2.0 يوجّه النموذج لتحريك تسلسل بناءً على ورقة شخصية، مع التركيز على حركات وخطوات محددة.',
  },
  'soul-switching-mirror-magic-sequence': {
    title: 'تسلسل سحري لتبديل الأرواح عبر المرآة',
    summary:
      'موجه فيديو سردي يصف حدثًا سحريًا لتبديل الأرواح عند مرآة، مع تعليمات محددة للكاميرا وإشارات عاطفية لكل مقطع.',
  },
  'toaster-rocket-jumpscare': {
    title: 'إخافة مفاجئة من محمصة الخبز',
    summary:
      'موجه للقطة بأسلوب فيديو منزلي واقعي لرجل عجوز يتعرض لإخافة مفاجئة من محمصة خبز تطلق قطعة خبز كأنها صاروخ.',
  },
  'traditional-dance-performance': {
    title: 'عرض رقص تقليدي',
    summary:
      'موجه فيديو شامل لـ Seedance 2.0 لتوليد رقصة تقليدية رشيقة بناءً على الكوريغرافيا وصور مرجعية للهوية.',
  },
  'video-seedance-three-kingdoms-guanyu-slaying-yanliang': {
    title: 'فيديو - لعبة الممالك الثلاث ARPG - قوان يو يقتل يان ليانغ (Seedance 2.0)',
    summary:
      'تسلسل حركة سينمائي داخل المحرك مدته ~10 ثوانٍ يجسّد قالب الصورة المرافق game-screenshot-three-kingdoms-guanyu-slaying-yanliang. يمتطي قوان يو (关羽) حصانه الأرنب الأحمر مندفعًا مباشرة نحو صف معركة العدو، يرفع نصل التنين الأخضر الهلالي، وينفذ ضربة قطع نظيفة واحدة ضد الجنرال المعادي يان ليانغ. مضبوط لـ Seedance 2.0 — انضباط محكم للكاميرا، ضربة حاسمة واحدة، فيزياء نظيفة للحصان والنصل، إضاءة فائقة الواقعية، وغياب تام لأي مشاهد دموية (الضربة موحى بها بومضة طاقة (qi) ذهبية، وليس بأي دماء). مصمم ليكون المرافق المباشر بالفيديو لقالب الصورة المطابق بحيث يمكن تقديم الصورة الثابتة والمقطع كزوج. الصورة المرجعية: قالب لقطة شاشة قوان يو وهو يقتل يان ليانغ.',
  },
  'video-seedance-three-kingdoms-lyubu-yuanmen-archery': {
    title: 'فيديو - لعبة الممالك الثلاث ARPG - لو بو ورماية يوانمن (Seedance 2.0)',
    summary:
      'تسلسل حركة سينمائي داخل المحرك مدته ~10 ثوانٍ يجسّد قالب الصورة المرافق game-screenshot-three-kingdoms-lyubu-yuanmen-archery. يقف لو بو (吕布) في وسط معسكر عسكري مغبر بين جيشين متقابلين، يسحب قوسًا طويلاً مطليًا باللاكيه الأحمر، يحبس النفس على وضع السحب، ثم يطلق سهمًا واحدًا متوهجًا بالذهب ومشبعًا بالطاقة (qi) عبر الميدان نحو حربة بعيدة مغروسة في الأرض. مضبوط لـ Seedance 2.0 — انضباط محكم للكاميرا، نبضة حاسمة واحدة، تأطير واضح وآمن لواجهة HUD، فيزياء نظيفة للقوس والسهم، حركة الرياح + الغبار + الرايات، وتدرج لوني بأسلوب لقطة شاشة داخل اللعبة. مصمم ليكون المرافق المباشر بالفيديو لقالب الصورة المطابق بحيث يمكن تقديم الصورة الثابتة والمقطع كزوج. الصورة المرجعية: قالب لقطة شاشة لو بو ورماية يوانمن.',
  },
  'video-seedance-three-kingdoms-zhaoyun-cradle-escape': {
    title: 'فيديو - لعبة الممالك الثلاث ARPG - هروب تشاو يون بالطفل (Seedance 2.0)',
    summary:
      'تسلسل حركة سينمائي داخل المحرك مدته ~12 ثانية يجسّد قالب الصورة المرافق game-screenshot-three-kingdoms-zhaoyun-cradle-escape. يمتطي تشاو يون (赵云) حصانه الحربي عبر ساحة معركة تشانغبان المحطمة، حاضنًا الوريث الرضيع آه دو في ثنية ذراعه اليسرى ومستخدمًا رمحه باليمنى، يصد ضربة قادمة بمراوغة مثالية واحدة (PERFECT DODGE) ويقفز متجاوزًا عربة حرب ساقطة ليفتح طريقًا. مضبوط لـ Seedance 2.0 — انضباط محكم للكاميرا، نبضة واحدة متواصلة، استخدام مقنع للرمح بذراع واحدة، فيزياء نظيفة للحصان، وغياب تام لأي أذى مرئي للرضيع. مصمم ليكون المرافق المباشر بالفيديو لقالب الصورة المطابق بحيث يمكن تقديم الصورة الثابتة والمقطع كزوج. الصورة المرجعية: قالب لقطة شاشة هروب تشاو يون بالطفل.',
  },
  'vintage-disney-style-pirate-crocodile-animation': {
    title: 'رسوم متحركة عتيقة بأسلوب Disney لتمساح قرصان',
    summary:
      'موجه سردي متعدد المشاهد لرسوم متحركة كلاسيكية عتيقة بأسلوب Disney تتضمن تمساحًا قرصانًا وطيورًا قرصانة على متن سفينة.',
  },
  'viral-k-pop-dance-choreography': {
    title: 'كوريغرافيا رقص K-pop رائجة',
    summary:
      'موجه مفصّل لـ Seedance 2.0 لتحريك شخصية تؤدي رقصة بناءً على مرجع لوحة قصصية من 16 لوحة.',
  },
  'wasteland-factory-chase': {
    title: 'مطاردة في مصنع الأرض القفر',
    summary:
      'موجه سينمائي لمشهد عالي السرعة في أرض صحراوية قفر يتضمن مصنعًا صناعيًا متحركًا على أرجل ومطاردة دراجة نارية لأحد المتمردين.',
  },
};
